import * as p from "react";
import { jsx as C, jsxs as Se } from "react/jsx-runtime";
import { P as a, _ as E } from "./TablePaginationActions-BmvmVQd9.js";
import { useThemeProps as pe, styled as B, alpha as $e } from "@mui/material/styles";
import pt from "@mui/material/MenuItem";
import ht from "@mui/material/MenuList";
import Ye from "@mui/material/IconButton";
import gt from "@mui/material/Typography";
import { createSvgIcon as Ce } from "@mui/material/utils";
import { styled as $t, MenuItem as Lt } from "@mui/material";
function ie(e, t) {
  if (e == null) return {};
  var n = {};
  for (var o in e) if ({}.hasOwnProperty.call(e, o)) {
    if (t.includes(o)) continue;
    n[o] = e[o];
  }
  return n;
}
function bt(e) {
  var t, n, o = "";
  if (typeof e == "string" || typeof e == "number") o += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var r = e.length;
    for (t = 0; t < r; t++) e[t] && (n = bt(e[t])) && (o && (o += " "), o += n);
  } else for (n in e) e[n] && (o && (o += " "), o += n);
  return o;
}
function te() {
  for (var e, t, n = 0, o = "", r = arguments.length; n < r; n++) (e = arguments[n]) && (t = bt(e)) && (o && (o += " "), o += t);
  return o;
}
const Ht = /* @__PURE__ */ p.createContext();
process.env.NODE_ENV !== "production" && (a.node, a.bool);
const yt = () => {
  const e = p.useContext(Ht);
  return e ?? !1;
};
function Ft(e, t) {
  typeof e == "function" ? e(t) : e && (e.current = t);
}
const wt = typeof window < "u" ? p.useLayoutEffect : p.useEffect;
let nt = 0;
function Bt(e) {
  const [t, n] = p.useState(e), o = e || t;
  return p.useEffect(() => {
    t == null && (nt += 1, n(`mui-${nt}`));
  }, [t]), o;
}
const _t = {
  ...p
}, ot = _t.useId;
function zt(e) {
  if (ot !== void 0) {
    const t = ot();
    return e ?? t;
  }
  return Bt(e);
}
function We({
  controlled: e,
  default: t,
  name: n,
  state: o = "value"
}) {
  const {
    current: r
  } = p.useRef(e !== void 0), [s, i] = p.useState(t), u = r ? e : s;
  if (process.env.NODE_ENV !== "production") {
    p.useEffect(() => {
      r !== (e !== void 0) && console.error([`MUI: A component is changing the ${r ? "" : "un"}controlled ${o} state of ${n} to be ${r ? "un" : ""}controlled.`, "Elements should not switch from uncontrolled to controlled (or vice versa).", `Decide between using a controlled or uncontrolled ${n} element for the lifetime of the component.`, "The nature of the state is determined during the first render. It's considered controlled if the value is not `undefined`.", "More info: https://fb.me/react-controlled-components"].join(`
`));
    }, [o, n, e]);
    const {
      current: c
    } = p.useRef(t);
    p.useEffect(() => {
      !r && !Object.is(c, t) && console.error([`MUI: A component is changing the default ${o} state of an uncontrolled ${n} after being initialized. To suppress this warning opt to use a controlled ${n}.`].join(`
`));
    }, [JSON.stringify(t)]);
  }
  const l = p.useCallback((c) => {
    r || i(c);
  }, []);
  return [u, l];
}
function ae(e) {
  const t = p.useRef(e);
  return wt(() => {
    t.current = e;
  }), p.useRef((...n) => (
    // @ts-expect-error hide `this`
    (0, t.current)(...n)
  )).current;
}
function Ge(...e) {
  return p.useMemo(() => e.every((t) => t == null) ? null : (t) => {
    e.forEach((n) => {
      Ft(n, t);
    });
  }, e);
}
function Me(e, t, n = void 0) {
  const o = {};
  for (const r in e) {
    const s = e[r];
    let i = "", u = !0;
    for (let l = 0; l < s.length; l += 1) {
      const c = s[l];
      c && (i += (u === !0 ? "" : " ") + t(c), u = !1, n && n[c] && (i += " " + n[c]));
    }
    o[r] = i;
  }
  return o;
}
const rt = (e) => e, jt = () => {
  let e = rt;
  return {
    configure(t) {
      e = t;
    },
    generate(t) {
      return e(t);
    },
    reset() {
      e = rt;
    }
  };
}, Wt = jt(), Ut = {
  active: "active",
  checked: "checked",
  completed: "completed",
  disabled: "disabled",
  error: "error",
  expanded: "expanded",
  focused: "focused",
  focusVisible: "focusVisible",
  open: "open",
  readOnly: "readOnly",
  required: "required",
  selected: "selected"
};
function he(e, t, n = "Mui") {
  const o = Ut[t];
  return o ? `${n}-${o}` : `${Wt.generate(e)}-${t}`;
}
function De(e, t, n = "Mui") {
  const o = {};
  return t.forEach((r) => {
    o[r] = he(e, r, n);
  }), o;
}
function Yt(e) {
  return typeof e == "string";
}
function Gt(e, t, n) {
  return e === void 0 || Yt(e) ? t : {
    ...t,
    ownerState: {
      ...t.ownerState,
      ...n
    }
  };
}
function qt(e, t = []) {
  if (e === void 0)
    return {};
  const n = {};
  return Object.keys(e).filter((o) => o.match(/^on[A-Z]/) && typeof e[o] == "function" && !t.includes(o)).forEach((o) => {
    n[o] = e[o];
  }), n;
}
function st(e) {
  if (e === void 0)
    return {};
  const t = {};
  return Object.keys(e).filter((n) => !(n.match(/^on[A-Z]/) && typeof e[n] == "function")).forEach((n) => {
    t[n] = e[n];
  }), t;
}
function Zt(e) {
  const {
    getSlotProps: t,
    additionalProps: n,
    externalSlotProps: o,
    externalForwardedProps: r,
    className: s
  } = e;
  if (!t) {
    const g = te(n == null ? void 0 : n.className, s, r == null ? void 0 : r.className, o == null ? void 0 : o.className), d = {
      ...n == null ? void 0 : n.style,
      ...r == null ? void 0 : r.style,
      ...o == null ? void 0 : o.style
    }, y = {
      ...n,
      ...r,
      ...o
    };
    return g.length > 0 && (y.className = g), Object.keys(d).length > 0 && (y.style = d), {
      props: y,
      internalRef: void 0
    };
  }
  const i = qt({
    ...r,
    ...o
  }), u = st(o), l = st(r), c = t(i), f = te(c == null ? void 0 : c.className, n == null ? void 0 : n.className, s, r == null ? void 0 : r.className, o == null ? void 0 : o.className), m = {
    ...c == null ? void 0 : c.style,
    ...n == null ? void 0 : n.style,
    ...r == null ? void 0 : r.style,
    ...o == null ? void 0 : o.style
  }, b = {
    ...c,
    ...n,
    ...l,
    ...u
  };
  return f.length > 0 && (b.className = f), Object.keys(m).length > 0 && (b.style = m), {
    props: b,
    internalRef: c.ref
  };
}
function Kt(e, t, n) {
  return typeof e == "function" ? e(t, n) : e;
}
function Ne(e) {
  var m;
  const {
    elementType: t,
    externalSlotProps: n,
    ownerState: o,
    skipResolvingSlotProps: r = !1,
    ...s
  } = e, i = r ? {} : Kt(n, o), {
    props: u,
    internalRef: l
  } = Zt({
    ...s,
    externalSlotProps: i
  }), c = Ge(l, i == null ? void 0 : i.ref, (m = e.additionalProps) == null ? void 0 : m.ref);
  return Gt(t, {
    ...u,
    ref: c
  }, o);
}
const Xt = ["localeText"], Le = /* @__PURE__ */ p.createContext(null);
process.env.NODE_ENV !== "production" && (Le.displayName = "MuiPickersAdapterContext");
const Jt = function(t) {
  const {
    localeText: n
  } = t, o = ie(t, Xt), {
    utils: r,
    localeText: s
  } = p.useContext(Le) ?? {
    utils: void 0,
    localeText: void 0
  }, i = pe({
    // We don't want to pass the `localeText` prop to the theme, that way it will always return the theme value,
    // We will then merge this theme value with our value manually
    props: o,
    name: "MuiLocalizationProvider"
  }), {
    children: u,
    dateAdapter: l,
    dateFormats: c,
    dateLibInstance: f,
    adapterLocale: m,
    localeText: b
  } = i, g = p.useMemo(() => E({}, b, s, n), [b, s, n]), d = p.useMemo(() => {
    if (!l)
      return r || null;
    const P = new l({
      locale: m,
      formats: c,
      instance: f
    });
    if (!P.isMUIAdapter)
      throw new Error(["MUI X: The date adapter should be imported from `@mui/x-date-pickers` or `@mui/x-date-pickers-pro`, not from `@date-io`", "For example, `import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'` instead of `import AdapterDayjs from '@date-io/dayjs'`", "More information on the installation documentation: https://mui.com/x/react-date-pickers/getting-started/#installation"].join(`
`));
    return P;
  }, [l, m, c, f, r]), y = p.useMemo(() => d ? {
    minDate: d.date("1900-01-01T00:00:00.000"),
    maxDate: d.date("2099-12-31T00:00:00.000")
  } : null, [d]), k = p.useMemo(() => ({
    utils: d,
    defaultDates: y,
    localeText: g
  }), [y, d, g]);
  return /* @__PURE__ */ C(Le.Provider, {
    value: k,
    children: u
  });
};
process.env.NODE_ENV !== "production" && (Jt.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Locale for the date library you are using
   */
  adapterLocale: a.any,
  children: a.node,
  /**
   * Date library adapter class function.
   * @see See the localization provider {@link https://mui.com/x/react-date-pickers/getting-started/#setup-your-date-library-adapter date adapter setup section} for more details.
   */
  dateAdapter: a.func,
  /**
   * Formats that are used for any child pickers
   */
  dateFormats: a.shape({
    dayOfMonth: a.string,
    dayOfMonthFull: a.string,
    fullDate: a.string,
    fullTime: a.string,
    fullTime12h: a.string,
    fullTime24h: a.string,
    hours12h: a.string,
    hours24h: a.string,
    keyboardDate: a.string,
    keyboardDateTime: a.string,
    keyboardDateTime12h: a.string,
    keyboardDateTime24h: a.string,
    meridiem: a.string,
    minutes: a.string,
    month: a.string,
    monthShort: a.string,
    normalDate: a.string,
    normalDateWithWeekday: a.string,
    seconds: a.string,
    shortDate: a.string,
    weekday: a.string,
    weekdayShort: a.string,
    year: a.string
  }),
  /**
   * Date library instance you are using, if it has some global overrides
   * ```jsx
   * dateLibInstance={momentTimeZone}
   * ```
   */
  dateLibInstance: a.any,
  /**
   * Locale for components texts
   */
  localeText: a.object
});
const Qt = (e) => ({
  components: {
    MuiLocalizationProvider: {
      defaultProps: {
        localeText: E({}, e)
      }
    }
  }
}), Fo = (e) => {
  const {
    utils: t,
    formatKey: n,
    contextTranslation: o,
    propsTranslation: r
  } = e;
  return (s) => {
    const i = s !== null && t.isValid(s) ? t.format(s, n) : null;
    return (r ?? o)(s, t, i);
  };
}, vt = {
  // Calendar navigation
  previousMonth: "Previous month",
  nextMonth: "Next month",
  // View navigation
  openPreviousView: "Open previous view",
  openNextView: "Open next view",
  calendarViewSwitchingButtonAriaLabel: (e) => e === "year" ? "year view is open, switch to calendar view" : "calendar view is open, switch to year view",
  // DateRange labels
  start: "Start",
  end: "End",
  startDate: "Start date",
  startTime: "Start time",
  endDate: "End date",
  endTime: "End time",
  // Action bar
  cancelButtonLabel: "Cancel",
  clearButtonLabel: "Clear",
  okButtonLabel: "OK",
  todayButtonLabel: "Today",
  // Toolbar titles
  datePickerToolbarTitle: "Select date",
  dateTimePickerToolbarTitle: "Select date & time",
  timePickerToolbarTitle: "Select time",
  dateRangePickerToolbarTitle: "Select date range",
  // Clock labels
  clockLabelText: (e, t, n, o) => `Select ${e}. ${!o && (t === null || !n.isValid(t)) ? "No time selected" : `Selected time is ${o ?? n.format(t, "fullTime")}`}`,
  hoursClockNumberText: (e) => `${e} hours`,
  minutesClockNumberText: (e) => `${e} minutes`,
  secondsClockNumberText: (e) => `${e} seconds`,
  // Digital clock labels
  selectViewText: (e) => `Select ${e}`,
  // Calendar labels
  calendarWeekNumberHeaderLabel: "Week number",
  calendarWeekNumberHeaderText: "#",
  calendarWeekNumberAriaLabelText: (e) => `Week ${e}`,
  calendarWeekNumberText: (e) => `${e}`,
  // Open picker labels
  openDatePickerDialogue: (e, t, n) => n || e !== null && t.isValid(e) ? `Choose date, selected date is ${n ?? t.format(e, "fullDate")}` : "Choose date",
  openTimePickerDialogue: (e, t, n) => n || e !== null && t.isValid(e) ? `Choose time, selected time is ${n ?? t.format(e, "fullTime")}` : "Choose time",
  fieldClearLabel: "Clear",
  // Table labels
  timeTableLabel: "pick time",
  dateTableLabel: "pick date",
  // Field section placeholders
  fieldYearPlaceholder: (e) => "Y".repeat(e.digitAmount),
  fieldMonthPlaceholder: (e) => e.contentType === "letter" ? "MMMM" : "MM",
  fieldDayPlaceholder: () => "DD",
  fieldWeekDayPlaceholder: (e) => e.contentType === "letter" ? "EEEE" : "EE",
  fieldHoursPlaceholder: () => "hh",
  fieldMinutesPlaceholder: () => "mm",
  fieldSecondsPlaceholder: () => "ss",
  fieldMeridiemPlaceholder: () => "aa",
  // View names
  year: "Year",
  month: "Month",
  day: "Day",
  weekDay: "Week day",
  hours: "Hours",
  minutes: "Minutes",
  seconds: "Seconds",
  meridiem: "Meridiem",
  // Common
  empty: "Empty"
}, en = vt;
Qt(vt);
const qe = () => {
  const e = p.useContext(Le);
  if (e === null)
    throw new Error(["MUI X: Can not find the date and time pickers localization context.", "It looks like you forgot to wrap your component in LocalizationProvider.", "This can also happen if you are bundling multiple versions of the `@mui/x-date-pickers` package"].join(`
`));
  if (e.utils === null)
    throw new Error(["MUI X: Can not find the date and time pickers adapter from its localization context.", "It looks like you forgot to pass a `dateAdapter` to your LocalizationProvider."].join(`
`));
  const t = p.useMemo(() => E({}, en, e.localeText), [e.localeText]);
  return p.useMemo(() => E({}, e, {
    localeText: t
  }), [e, t]);
}, ge = () => qe().utils, Bo = () => qe().defaultDates, Ze = (e) => {
  const t = ge(), n = p.useRef();
  return n.current === void 0 && (n.current = t.date(void 0, e)), n.current;
}, Be = () => qe().localeText, _o = Ce(/* @__PURE__ */ C("path", {
  d: "M7 10l5 5 5-5z"
}), "ArrowDropDown"), tn = Ce(/* @__PURE__ */ C("path", {
  d: "M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"
}), "ArrowLeft"), nn = Ce(/* @__PURE__ */ C("path", {
  d: "M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"
}), "ArrowRight"), zo = Ce(/* @__PURE__ */ C("path", {
  d: "M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z"
}), "Calendar"), jo = Ce(/* @__PURE__ */ Se(p.Fragment, {
  children: [/* @__PURE__ */ C("path", {
    d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
  }), /* @__PURE__ */ C("path", {
    d: "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
  })]
}), "Clock"), Wo = Ce(/* @__PURE__ */ C("path", {
  d: "M9 11H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2zm2-7h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V9h14v11z"
}), "DateRange"), Uo = Ce(/* @__PURE__ */ Se(p.Fragment, {
  children: [/* @__PURE__ */ C("path", {
    d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
  }), /* @__PURE__ */ C("path", {
    d: "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
  })]
}), "Time"), Yo = Ce(/* @__PURE__ */ C("path", {
  d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), "Clear");
function on(e) {
  return he("MuiPickersArrowSwitcher", e);
}
De("MuiPickersArrowSwitcher", ["root", "spacer", "button", "previousIconButton", "nextIconButton", "leftArrowIcon", "rightArrowIcon"]);
const rn = ["children", "className", "slots", "slotProps", "isNextDisabled", "isNextHidden", "onGoToNext", "nextLabel", "isPreviousDisabled", "isPreviousHidden", "onGoToPrevious", "previousLabel", "labelId"], sn = ["ownerState"], an = ["ownerState"], ln = B("div", {
  name: "MuiPickersArrowSwitcher",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  display: "flex"
}), cn = B("div", {
  name: "MuiPickersArrowSwitcher",
  slot: "Spacer",
  overridesResolver: (e, t) => t.spacer
})(({
  theme: e
}) => ({
  width: e.spacing(3)
})), at = B(Ye, {
  name: "MuiPickersArrowSwitcher",
  slot: "Button",
  overridesResolver: (e, t) => t.button
})({
  variants: [{
    props: {
      hidden: !0
    },
    style: {
      visibility: "hidden"
    }
  }]
}), un = (e) => {
  const {
    classes: t
  } = e;
  return Me({
    root: ["root"],
    spacer: ["spacer"],
    button: ["button"],
    previousIconButton: ["previousIconButton"],
    nextIconButton: ["nextIconButton"],
    leftArrowIcon: ["leftArrowIcon"],
    rightArrowIcon: ["rightArrowIcon"]
  }, on, t);
}, dn = /* @__PURE__ */ p.forwardRef(function(t, n) {
  const o = yt(), r = pe({
    props: t,
    name: "MuiPickersArrowSwitcher"
  }), {
    children: s,
    className: i,
    slots: u,
    slotProps: l,
    isNextDisabled: c,
    isNextHidden: f,
    onGoToNext: m,
    nextLabel: b,
    isPreviousDisabled: g,
    isPreviousHidden: d,
    onGoToPrevious: y,
    previousLabel: k,
    labelId: P
  } = r, M = ie(r, rn), V = r, N = un(V), R = {
    isDisabled: c,
    isHidden: f,
    goTo: m,
    label: b
  }, H = {
    isDisabled: g,
    isHidden: d,
    goTo: y,
    label: k
  }, h = (u == null ? void 0 : u.previousIconButton) ?? at, x = Ne({
    elementType: h,
    externalSlotProps: l == null ? void 0 : l.previousIconButton,
    additionalProps: {
      size: "medium",
      title: H.label,
      "aria-label": H.label,
      disabled: H.isDisabled,
      edge: "end",
      onClick: H.goTo
    },
    ownerState: E({}, V, {
      hidden: H.isHidden
    }),
    className: te(N.button, N.previousIconButton)
  }), O = (u == null ? void 0 : u.nextIconButton) ?? at, $ = Ne({
    elementType: O,
    externalSlotProps: l == null ? void 0 : l.nextIconButton,
    additionalProps: {
      size: "medium",
      title: R.label,
      "aria-label": R.label,
      disabled: R.isDisabled,
      edge: "start",
      onClick: R.goTo
    },
    ownerState: E({}, V, {
      hidden: R.isHidden
    }),
    className: te(N.button, N.nextIconButton)
  }), I = (u == null ? void 0 : u.leftArrowIcon) ?? tn, K = Ne({
    elementType: I,
    externalSlotProps: l == null ? void 0 : l.leftArrowIcon,
    additionalProps: {
      fontSize: "inherit"
    },
    ownerState: V,
    className: N.leftArrowIcon
  }), _ = ie(K, sn), ne = (u == null ? void 0 : u.rightArrowIcon) ?? nn, oe = Ne({
    elementType: ne,
    externalSlotProps: l == null ? void 0 : l.rightArrowIcon,
    additionalProps: {
      fontSize: "inherit"
    },
    ownerState: V,
    className: N.rightArrowIcon
  }), le = ie(oe, an);
  return /* @__PURE__ */ Se(ln, E({
    ref: n,
    className: te(N.root, i),
    ownerState: V
  }, M, {
    children: [/* @__PURE__ */ C(h, E({}, x, {
      children: o ? /* @__PURE__ */ C(ne, E({}, le)) : /* @__PURE__ */ C(I, E({}, _))
    })), s ? /* @__PURE__ */ C(gt, {
      variant: "subtitle1",
      component: "span",
      id: P,
      children: s
    }) : /* @__PURE__ */ C(cn, {
      className: N.spacer,
      ownerState: V
    }), /* @__PURE__ */ C(O, E({}, $, {
      children: o ? /* @__PURE__ */ C(I, E({}, _)) : /* @__PURE__ */ C(ne, E({}, le))
    }))]
  }));
}), ue = (e, t) => e.length !== t.length ? !1 : t.every((n) => e.includes(n)), Go = ({
  openTo: e,
  defaultOpenTo: t,
  views: n,
  defaultViews: o
}) => {
  const r = n ?? o;
  let s;
  if (e != null)
    s = e;
  else if (r.includes(t))
    s = t;
  else if (r.length > 0)
    s = r[0];
  else
    throw new Error("MUI X: The `views` prop must contain at least one view.");
  return {
    views: r,
    openTo: s
  };
}, St = ["hours", "minutes", "seconds"], He = (e) => St.includes(e), qo = (e) => St.includes(e) || e === "meridiem", mn = (e, t) => e ? t.getHours(e) >= 12 ? "pm" : "am" : null, Oe = (e, t, n) => n && (e >= 12 ? "pm" : "am") !== t ? t === "am" ? e - 12 : e + 12 : e, fn = (e, t, n, o) => {
  const r = Oe(o.getHours(e), t, n);
  return o.setHours(e, r);
}, it = (e, t) => t.getHours(e) * 3600 + t.getMinutes(e) * 60 + t.getSeconds(e), _e = (e, t) => (n, o) => e ? t.isAfter(n, o) : it(n, t) > it(o, t), Zo = (e, {
  format: t,
  views: n,
  ampm: o
}) => {
  if (t != null)
    return t;
  const r = e.formats;
  return ue(n, ["hours"]) ? o ? `${r.hours12h} ${r.meridiem}` : r.hours24h : ue(n, ["minutes"]) ? r.minutes : ue(n, ["seconds"]) ? r.seconds : ue(n, ["minutes", "seconds"]) ? `${r.minutes}:${r.seconds}` : ue(n, ["hours", "minutes", "seconds"]) ? o ? `${r.hours12h}:${r.minutes}:${r.seconds} ${r.meridiem}` : `${r.hours24h}:${r.minutes}:${r.seconds}` : o ? `${r.hours12h}:${r.minutes} ${r.meridiem}` : `${r.hours24h}:${r.minutes}`;
};
let je = !1;
function Ke({
  onChange: e,
  onViewChange: t,
  openTo: n,
  view: o,
  views: r,
  autoFocus: s,
  focusedView: i,
  onFocusedViewChange: u
}) {
  process.env.NODE_ENV !== "production" && (je || (o != null && !r.includes(o) && (console.warn(`MUI X: \`view="${o}"\` is not a valid prop.`, `It must be an element of \`views=["${r.join('", "')}"]\`.`), je = !0), o == null && n != null && !r.includes(n) && (console.warn(`MUI X: \`openTo="${n}"\` is not a valid prop.`, `It must be an element of \`views=["${r.join('", "')}"]\`.`), je = !0)));
  const l = p.useRef(n), c = p.useRef(r), f = p.useRef(r.includes(n) ? n : r[0]), [m, b] = We({
    name: "useViews",
    state: "view",
    controlled: o,
    default: f.current
  }), g = p.useRef(s ? m : null), [d, y] = We({
    name: "useViews",
    state: "focusedView",
    controlled: i,
    default: g.current
  });
  p.useEffect(() => {
    (l.current && l.current !== n || c.current && c.current.some((h) => !r.includes(h))) && (b(r.includes(n) ? n : r[0]), c.current = r, l.current = n);
  }, [n, b, m, r]);
  const k = r.indexOf(m), P = r[k - 1] ?? null, M = r[k + 1] ?? null, V = ae((h, x) => {
    y(x ? h : (O) => h === O ? null : O), u == null || u(h, x);
  }), N = ae((h) => {
    V(h, !0), h !== m && (b(h), t && t(h));
  }), R = ae(() => {
    M && N(M);
  }), H = ae((h, x, O) => {
    const $ = x === "finish", I = O ? (
      // handles case like `DateTimePicker`, where a view might return a `finish` selection state
      // but when it's not the final view given all `views` -> overall selection state should be `partial`.
      r.indexOf(O) < r.length - 1
    ) : !!M;
    if (e(h, $ && I ? "partial" : x, O), O && O !== m) {
      const _ = r[r.indexOf(O) + 1];
      _ && N(_);
    } else $ && R();
  });
  return {
    view: m,
    setView: N,
    focusedView: d,
    setFocusedView: V,
    nextView: M,
    previousView: P,
    // Always return up-to-date default view instead of the initial one (i.e. defaultView.current)
    defaultView: r.includes(n) ? n : r[0],
    goToNextView: R,
    setValueAndGoToNextView: H
  };
}
function Ko(e, {
  disableFuture: t,
  maxDate: n,
  timezone: o
}) {
  const r = ge();
  return p.useMemo(() => {
    const s = r.date(void 0, o), i = r.startOfMonth(t && r.isBefore(s, n) ? s : n);
    return !r.isAfter(i, e);
  }, [t, n, e, r, o]);
}
function Xo(e, {
  disablePast: t,
  minDate: n,
  timezone: o
}) {
  const r = ge();
  return p.useMemo(() => {
    const s = r.date(void 0, o), i = r.startOfMonth(t && r.isAfter(s, n) ? s : n);
    return !r.isBefore(i, e);
  }, [t, n, e, r, o]);
}
function Ct(e, t, n, o) {
  const r = ge(), s = mn(e, r), i = p.useCallback((u) => {
    const l = e == null ? null : fn(e, u, !!t, r);
    n(l, o ?? "partial");
  }, [t, e, n, o, r]);
  return {
    meridiemMode: s,
    handleMeridiemChange: i
  };
}
const Jo = 36, Qo = 2, pn = 320, er = 280, hn = 336, Mt = 232, gn = 48, Xe = B("div")({
  overflow: "hidden",
  width: pn,
  maxHeight: hn,
  display: "flex",
  flexDirection: "column",
  margin: "0 auto"
});
function bn(e) {
  return he("MuiTimeClock", e);
}
De("MuiTimeClock", ["root", "arrowSwitcher"]);
const Te = 220, fe = 36, Pe = {
  x: Te / 2,
  y: Te / 2
}, Dt = {
  x: Pe.x,
  y: 0
}, yn = Dt.x - Pe.x, wn = Dt.y - Pe.y, vn = (e) => e * (180 / Math.PI), kt = (e, t, n) => {
  const o = t - Pe.x, r = n - Pe.y, s = Math.atan2(yn, wn) - Math.atan2(o, r);
  let i = vn(s);
  i = Math.round(i / e) * e, i %= 360;
  const u = Math.floor(i / e) || 0, l = o ** 2 + r ** 2, c = Math.sqrt(l);
  return {
    value: u,
    distance: c
  };
}, Sn = (e, t, n = 1) => {
  const o = n * 6;
  let {
    value: r
  } = kt(o, e, t);
  return r = r * n % 60, r;
}, Cn = (e, t, n) => {
  const {
    value: o,
    distance: r
  } = kt(30, e, t);
  let s = o || 12;
  return n ? s %= 12 : r < Te / 2 - fe && (s += 12, s %= 24), s;
};
function Mn(e) {
  return he("MuiClockPointer", e);
}
De("MuiClockPointer", ["root", "thumb"]);
const Dn = ["className", "hasSelected", "isInner", "type", "viewValue"], kn = (e) => {
  const {
    classes: t
  } = e;
  return Me({
    root: ["root"],
    thumb: ["thumb"]
  }, Mn, t);
}, xn = B("div", {
  name: "MuiClockPointer",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  theme: e
}) => ({
  width: 2,
  backgroundColor: (e.vars || e).palette.primary.main,
  position: "absolute",
  left: "calc(50% - 1px)",
  bottom: "50%",
  transformOrigin: "center bottom 0px",
  variants: [{
    props: {
      shouldAnimate: !0
    },
    style: {
      transition: e.transitions.create(["transform", "height"])
    }
  }]
})), Tn = B("div", {
  name: "MuiClockPointer",
  slot: "Thumb",
  overridesResolver: (e, t) => t.thumb
})(({
  theme: e
}) => ({
  width: 4,
  height: 4,
  backgroundColor: (e.vars || e).palette.primary.contrastText,
  borderRadius: "50%",
  position: "absolute",
  top: -21,
  left: `calc(50% - ${fe / 2}px)`,
  border: `${(fe - 4) / 2}px solid ${(e.vars || e).palette.primary.main}`,
  boxSizing: "content-box",
  variants: [{
    props: {
      hasSelected: !0
    },
    style: {
      backgroundColor: (e.vars || e).palette.primary.main
    }
  }]
}));
function In(e) {
  const t = pe({
    props: e,
    name: "MuiClockPointer"
  }), {
    className: n,
    isInner: o,
    type: r,
    viewValue: s
  } = t, i = ie(t, Dn), u = p.useRef(r);
  p.useEffect(() => {
    u.current = r;
  }, [r]);
  const l = E({}, t, {
    shouldAnimate: u.current !== r
  }), c = kn(l);
  return /* @__PURE__ */ C(xn, E({
    style: (() => {
      let b = 360 / (r === "hours" ? 12 : 60) * s;
      return r === "hours" && s > 12 && (b -= 360), {
        height: Math.round((o ? 0.26 : 0.4) * Te),
        transform: `rotateZ(${b}deg)`
      };
    })(),
    className: te(c.root, n),
    ownerState: l
  }, i, {
    children: /* @__PURE__ */ C(Tn, {
      ownerState: l,
      className: c.thumb
    })
  }));
}
function Vn(e) {
  return he("MuiClock", e);
}
De("MuiClock", ["root", "clock", "wrapper", "squareMask", "pin", "amButton", "pmButton", "meridiemText", "selected"]);
const Ue = (e, t, n) => {
  let o = t;
  return o = e.setHours(o, e.getHours(n)), o = e.setMinutes(o, e.getMinutes(n)), o = e.setSeconds(o, e.getSeconds(n)), o = e.setMilliseconds(o, e.getMilliseconds(n)), o;
}, tr = ({
  date: e,
  disableFuture: t,
  disablePast: n,
  maxDate: o,
  minDate: r,
  isDateDisabled: s,
  utils: i,
  timezone: u
}) => {
  const l = Ue(i, i.date(void 0, u), e);
  n && i.isBefore(r, l) && (r = l), t && i.isAfter(o, l) && (o = l);
  let c = e, f = e;
  for (i.isBefore(e, r) && (c = r, f = null), i.isAfter(e, o) && (f && (f = o), c = null); c || f; ) {
    if (c && i.isAfter(c, o) && (c = null), f && i.isBefore(f, r) && (f = null), c) {
      if (!s(c))
        return c;
      c = i.addDays(c, 1);
    }
    if (f) {
      if (!s(f))
        return f;
      f = i.addDays(f, -1);
    }
  }
  return null;
}, Nn = (e, t) => t == null || !e.isValid(t) ? null : t, nr = (e, t, n) => t == null || !e.isValid(t) ? n : t, On = (e, t, n) => !e.isValid(t) && t != null && !e.isValid(n) && n != null ? !0 : e.isEqual(t, n), xt = (e, t) => {
  const o = [e.startOfYear(t)];
  for (; o.length < 12; ) {
    const r = o[o.length - 1];
    o.push(e.addMonths(r, 1));
  }
  return o;
}, Je = (e, t, n) => n === "date" ? e.startOfDay(e.date(void 0, t)) : e.date(void 0, t), xe = (e, t) => {
  const n = e.setHours(e.date(), t === "am" ? 2 : 14);
  return e.format(n, "meridiem");
}, Pn = ["year", "month", "day"], or = (e) => Pn.includes(e), rr = (e, {
  format: t,
  views: n
}, o) => {
  if (t != null)
    return t;
  const r = e.formats;
  return ue(n, ["year"]) ? r.year : ue(n, ["month"]) ? r.month : ue(n, ["day"]) ? r.dayOfMonth : ue(n, ["month", "year"]) ? `${r.month} ${r.year}` : ue(n, ["day", "month"]) ? `${r.month} ${r.dayOfMonth}` : o ? /en/.test(e.getCurrentLocaleCode()) ? r.normalDateWithWeekday : r.normalDate : r.keyboardDate;
}, sr = (e, t) => {
  const n = e.startOfWeek(t);
  return [0, 1, 2, 3, 4, 5, 6].map((o) => e.addDays(n, o));
}, Rn = (e) => {
  const {
    classes: t,
    meridiemMode: n
  } = e;
  return Me({
    root: ["root"],
    clock: ["clock"],
    wrapper: ["wrapper"],
    squareMask: ["squareMask"],
    pin: ["pin"],
    amButton: ["amButton", n === "am" && "selected"],
    pmButton: ["pmButton", n === "pm" && "selected"],
    meridiemText: ["meridiemText"]
  }, Vn, t);
}, En = B("div", {
  name: "MuiClock",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  theme: e
}) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  margin: e.spacing(2)
})), An = B("div", {
  name: "MuiClock",
  slot: "Clock",
  overridesResolver: (e, t) => t.clock
})({
  backgroundColor: "rgba(0,0,0,.07)",
  borderRadius: "50%",
  height: 220,
  width: 220,
  flexShrink: 0,
  position: "relative",
  pointerEvents: "none"
}), $n = B("div", {
  name: "MuiClock",
  slot: "Wrapper",
  overridesResolver: (e, t) => t.wrapper
})({
  "&:focus": {
    outline: "none"
  }
}), Ln = B("div", {
  name: "MuiClock",
  slot: "SquareMask",
  overridesResolver: (e, t) => t.squareMask
})({
  width: "100%",
  height: "100%",
  position: "absolute",
  pointerEvents: "auto",
  outline: 0,
  // Disable scroll capabilities.
  touchAction: "none",
  userSelect: "none",
  variants: [{
    props: {
      disabled: !1
    },
    style: {
      "@media (pointer: fine)": {
        cursor: "pointer",
        borderRadius: "50%"
      },
      "&:active": {
        cursor: "move"
      }
    }
  }]
}), Hn = B("div", {
  name: "MuiClock",
  slot: "Pin",
  overridesResolver: (e, t) => t.pin
})(({
  theme: e
}) => ({
  width: 6,
  height: 6,
  borderRadius: "50%",
  backgroundColor: (e.vars || e).palette.primary.main,
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)"
})), Tt = (e, t) => ({
  zIndex: 1,
  bottom: 8,
  paddingLeft: 4,
  paddingRight: 4,
  width: fe,
  variants: [{
    props: {
      meridiemMode: t
    },
    style: {
      backgroundColor: (e.vars || e).palette.primary.main,
      color: (e.vars || e).palette.primary.contrastText,
      "&:hover": {
        backgroundColor: (e.vars || e).palette.primary.light
      }
    }
  }]
}), Fn = B(Ye, {
  name: "MuiClock",
  slot: "AmButton",
  overridesResolver: (e, t) => t.amButton
})(({
  theme: e
}) => E({}, Tt(e, "am"), {
  // keeping it here to make TS happy
  position: "absolute",
  left: 8
})), Bn = B(Ye, {
  name: "MuiClock",
  slot: "PmButton",
  overridesResolver: (e, t) => t.pmButton
})(({
  theme: e
}) => E({}, Tt(e, "pm"), {
  // keeping it here to make TS happy
  position: "absolute",
  right: 8
})), lt = B(gt, {
  name: "MuiClock",
  slot: "meridiemText",
  overridesResolver: (e, t) => t.meridiemText
})({
  overflow: "hidden",
  whiteSpace: "nowrap",
  textOverflow: "ellipsis"
});
function _n(e) {
  const t = pe({
    props: e,
    name: "MuiClock"
  }), {
    ampm: n,
    ampmInClock: o,
    autoFocus: r,
    children: s,
    value: i,
    handleMeridiemChange: u,
    isTimeDisabled: l,
    meridiemMode: c,
    minutesStep: f = 1,
    onChange: m,
    selectedId: b,
    type: g,
    viewValue: d,
    viewRange: [y, k],
    disabled: P = !1,
    readOnly: M,
    className: V
  } = t, N = t, R = ge(), H = Be(), h = p.useRef(!1), x = Rn(N), O = l(d, g), $ = !n && g === "hours" && (d < 1 || d > 12), I = (D, A) => {
    P || M || l(D, g) || m(D, A);
  }, K = (D, A) => {
    let {
      offsetX: Q,
      offsetY: j
    } = D;
    if (Q === void 0) {
      const q = D.target.getBoundingClientRect();
      Q = D.changedTouches[0].clientX - q.left, j = D.changedTouches[0].clientY - q.top;
    }
    const ee = g === "seconds" || g === "minutes" ? Sn(Q, j, f) : Cn(Q, j, !!n);
    I(ee, A);
  }, _ = (D) => {
    h.current = !0, K(D, "shallow");
  }, ne = (D) => {
    h.current && (K(D, "finish"), h.current = !1), D.preventDefault();
  }, oe = (D) => {
    D.buttons > 0 && K(D.nativeEvent, "shallow");
  }, le = (D) => {
    h.current && (h.current = !1), K(D.nativeEvent, "finish");
  }, ce = p.useMemo(() => g === "hours" ? !0 : d % 5 === 0, [g, d]), X = g === "minutes" ? f : 1, de = p.useRef(null);
  wt(() => {
    r && de.current.focus();
  }, [r]);
  const F = (D) => Math.max(y, Math.min(k, D)), z = (D) => (D + (k + 1)) % (k + 1), G = (D) => {
    if (!h.current)
      switch (D.key) {
        case "Home":
          I(y, "partial"), D.preventDefault();
          break;
        case "End":
          I(k, "partial"), D.preventDefault();
          break;
        case "ArrowUp":
          I(z(d + X), "partial"), D.preventDefault();
          break;
        case "ArrowDown":
          I(z(d - X), "partial"), D.preventDefault();
          break;
        case "PageUp":
          I(F(d + 5), "partial"), D.preventDefault();
          break;
        case "PageDown":
          I(F(d - 5), "partial"), D.preventDefault();
          break;
        case "Enter":
        case " ":
          I(d, "finish"), D.preventDefault();
          break;
      }
  };
  return /* @__PURE__ */ Se(En, {
    className: te(x.root, V),
    children: [/* @__PURE__ */ Se(An, {
      className: x.clock,
      children: [/* @__PURE__ */ C(Ln, {
        onTouchMove: _,
        onTouchStart: _,
        onTouchEnd: ne,
        onMouseUp: le,
        onMouseMove: oe,
        ownerState: {
          disabled: P
        },
        className: x.squareMask
      }), !O && /* @__PURE__ */ Se(p.Fragment, {
        children: [/* @__PURE__ */ C(Hn, {
          className: x.pin
        }), i != null && /* @__PURE__ */ C(In, {
          type: g,
          viewValue: d,
          isInner: $,
          hasSelected: ce
        })]
      }), /* @__PURE__ */ C($n, {
        "aria-activedescendant": b,
        "aria-label": H.clockLabelText(g, i, R, i == null ? null : R.format(i, "fullTime")),
        ref: de,
        role: "listbox",
        onKeyDown: G,
        tabIndex: 0,
        className: x.wrapper,
        children: s
      })]
    }), n && o && /* @__PURE__ */ Se(p.Fragment, {
      children: [/* @__PURE__ */ C(Fn, {
        onClick: M ? void 0 : () => u("am"),
        disabled: P || c === null,
        ownerState: N,
        className: x.amButton,
        title: xe(R, "am"),
        children: /* @__PURE__ */ C(lt, {
          variant: "caption",
          className: x.meridiemText,
          children: xe(R, "am")
        })
      }), /* @__PURE__ */ C(Bn, {
        disabled: P || c === null,
        onClick: M ? void 0 : () => u("pm"),
        ownerState: N,
        className: x.pmButton,
        title: xe(R, "pm"),
        children: /* @__PURE__ */ C(lt, {
          variant: "caption",
          className: x.meridiemText,
          children: xe(R, "pm")
        })
      })]
    })]
  });
}
function zn(e) {
  return he("MuiClockNumber", e);
}
const Ae = De("MuiClockNumber", ["root", "selected", "disabled"]), jn = ["className", "disabled", "index", "inner", "label", "selected"], Wn = (e) => {
  const {
    classes: t,
    selected: n,
    disabled: o
  } = e;
  return Me({
    root: ["root", n && "selected", o && "disabled"]
  }, zn, t);
}, Un = B("span", {
  name: "MuiClockNumber",
  slot: "Root",
  overridesResolver: (e, t) => [t.root, {
    [`&.${Ae.disabled}`]: t.disabled
  }, {
    [`&.${Ae.selected}`]: t.selected
  }]
})(({
  theme: e
}) => ({
  height: fe,
  width: fe,
  position: "absolute",
  left: `calc((100% - ${fe}px) / 2)`,
  display: "inline-flex",
  justifyContent: "center",
  alignItems: "center",
  borderRadius: "50%",
  color: (e.vars || e).palette.text.primary,
  fontFamily: e.typography.fontFamily,
  "&:focused": {
    backgroundColor: (e.vars || e).palette.background.paper
  },
  [`&.${Ae.selected}`]: {
    color: (e.vars || e).palette.primary.contrastText
  },
  [`&.${Ae.disabled}`]: {
    pointerEvents: "none",
    color: (e.vars || e).palette.text.disabled
  },
  variants: [{
    props: {
      inner: !0
    },
    style: E({}, e.typography.body2, {
      color: (e.vars || e).palette.text.secondary
    })
  }]
}));
function It(e) {
  const t = pe({
    props: e,
    name: "MuiClockNumber"
  }), {
    className: n,
    disabled: o,
    index: r,
    inner: s,
    label: i,
    selected: u
  } = t, l = ie(t, jn), c = t, f = Wn(c), m = r % 12 / 12 * Math.PI * 2 - Math.PI / 2, b = (Te - fe - 2) / 2 * (s ? 0.65 : 1), g = Math.round(Math.cos(m) * b), d = Math.round(Math.sin(m) * b);
  return /* @__PURE__ */ C(Un, E({
    className: te(f.root, n),
    "aria-disabled": o ? !0 : void 0,
    "aria-selected": u ? !0 : void 0,
    role: "option",
    style: {
      transform: `translate(${g}px, ${d + (Te - fe) / 2}px`
    },
    ownerState: c
  }, l, {
    children: i
  }));
}
const Yn = ({
  ampm: e,
  value: t,
  getClockNumberText: n,
  isDisabled: o,
  selectedId: r,
  utils: s
}) => {
  const i = t ? s.getHours(t) : null, u = [], l = e ? 1 : 0, c = e ? 12 : 23, f = (m) => i === null ? !1 : e ? m === 12 ? i === 12 || i === 0 : i === m || i - 12 === m : i === m;
  for (let m = l; m <= c; m += 1) {
    let b = m.toString();
    m === 0 && (b = "00");
    const g = !e && (m === 0 || m > 12);
    b = s.formatNumber(b);
    const d = f(m);
    u.push(/* @__PURE__ */ C(It, {
      id: d ? r : void 0,
      index: m,
      inner: g,
      selected: d,
      disabled: o(m),
      label: b,
      "aria-label": n(b)
    }, m));
  }
  return u;
}, ct = ({
  utils: e,
  value: t,
  isDisabled: n,
  getClockNumberText: o,
  selectedId: r
}) => {
  const s = e.formatNumber;
  return [[5, s("05")], [10, s("10")], [15, s("15")], [20, s("20")], [25, s("25")], [30, s("30")], [35, s("35")], [40, s("40")], [45, s("45")], [50, s("50")], [55, s("55")], [0, s("00")]].map(([i, u], l) => {
    const c = i === t;
    return /* @__PURE__ */ C(It, {
      label: u,
      id: c ? r : void 0,
      index: l + 1,
      inner: !1,
      disabled: n(i),
      selected: c,
      "aria-label": o(u)
    }, i);
  });
}, Gn = ({
  timezone: e,
  value: t,
  defaultValue: n,
  referenceDate: o,
  onChange: r,
  valueManager: s
}) => {
  const i = ge(), u = p.useRef(n), l = t ?? u.current ?? s.emptyValue, c = p.useMemo(() => s.getTimezone(i, l), [i, s, l]), f = ae((d) => c == null ? d : s.setTimezone(i, c, d));
  let m;
  e ? m = e : c ? m = c : o ? m = i.getTimezone(o) : m = "default";
  const b = p.useMemo(() => s.setTimezone(i, m, l), [s, i, m, l]), g = ae((d, ...y) => {
    const k = f(d);
    r == null || r(k, ...y);
  });
  return {
    value: b,
    handleValueChange: g,
    timezone: m
  };
}, Qe = ({
  name: e,
  timezone: t,
  value: n,
  defaultValue: o,
  referenceDate: r,
  onChange: s,
  valueManager: i
}) => {
  const [u, l] = We({
    name: e,
    state: "value",
    controlled: n,
    default: o ?? i.emptyValue
  }), c = ae((f, ...m) => {
    l(f), s == null || s(f, ...m);
  });
  return Gn({
    timezone: t,
    value: u,
    defaultValue: void 0,
    referenceDate: r,
    onChange: c,
    valueManager: i
  });
}, ve = {
  year: 1,
  month: 2,
  day: 3,
  hours: 4,
  minutes: 5,
  seconds: 6,
  milliseconds: 7
}, ar = (e) => Math.max(...e.map((t) => ve[t.type] ?? 1)), Ve = (e, t, n) => {
  if (t === ve.year)
    return e.startOfYear(n);
  if (t === ve.month)
    return e.startOfMonth(n);
  if (t === ve.day)
    return e.startOfDay(n);
  let o = n;
  return t < ve.minutes && (o = e.setMinutes(o, 0)), t < ve.seconds && (o = e.setSeconds(o, 0)), t < ve.milliseconds && (o = e.setMilliseconds(o, 0)), o;
}, qn = ({
  props: e,
  utils: t,
  granularity: n,
  timezone: o,
  getTodayDate: r
}) => {
  let s = r ? r() : Ve(t, n, Je(t, o));
  e.minDate != null && t.isAfterDay(e.minDate, s) && (s = Ve(t, n, e.minDate)), e.maxDate != null && t.isBeforeDay(e.maxDate, s) && (s = Ve(t, n, e.maxDate));
  const i = _e(e.disableIgnoringDatePartForTimeValidation ?? !1, t);
  return e.minTime != null && i(e.minTime, s) && (s = Ve(t, n, e.disableIgnoringDatePartForTimeValidation ? e.minTime : Ue(t, s, e.minTime))), e.maxTime != null && i(s, e.maxTime) && (s = Ve(t, n, e.disableIgnoringDatePartForTimeValidation ? e.maxTime : Ue(t, s, e.maxTime))), s;
}, Zn = (e, t) => {
  const n = e.formatTokenMap[t];
  if (n == null)
    throw new Error([`MUI X: The token "${t}" is not supported by the Date and Time Pickers.`, "Please try using another token or open an issue on https://github.com/mui/mui-x/issues/new/choose if you think it should be supported."].join(`
`));
  return typeof n == "string" ? {
    type: n,
    contentType: n === "meridiem" ? "letter" : "digit",
    maxLength: void 0
  } : {
    type: n.sectionType,
    contentType: n.contentType,
    maxLength: n.maxLength
  };
}, Kn = (e) => {
  switch (e) {
    case "ArrowUp":
      return 1;
    case "ArrowDown":
      return -1;
    case "PageUp":
      return 5;
    case "PageDown":
      return -5;
    default:
      return 0;
  }
}, et = (e, t) => {
  const n = [], o = e.date(void 0, "default"), r = e.startOfWeek(o), s = e.endOfWeek(o);
  let i = r;
  for (; e.isBefore(i, s); )
    n.push(i), i = e.addDays(i, 1);
  return n.map((u) => e.formatByString(u, t));
}, Xn = (e, t, n, o) => {
  switch (n) {
    case "month":
      return xt(e, e.date(void 0, t)).map((r) => e.formatByString(r, o));
    case "weekDay":
      return et(e, o);
    case "meridiem": {
      const r = e.date(void 0, t);
      return [e.startOfDay(r), e.endOfDay(r)].map((s) => e.formatByString(s, o));
    }
    default:
      return [];
  }
}, ut = "s", Jn = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"], ir = (e) => {
  const t = e.date(void 0);
  return e.formatByString(e.setSeconds(t, 0), ut) === "0" ? Jn : Array.from({
    length: 10
  }).map((o, r) => e.formatByString(e.setSeconds(t, r), ut));
}, Re = (e, t) => {
  if (t[0] === "0")
    return e;
  const n = [];
  let o = "";
  for (let r = 0; r < e.length; r += 1) {
    o += e[r];
    const s = t.indexOf(o);
    s > -1 && (n.push(s.toString()), o = "");
  }
  return n.join("");
}, Qn = (e, t) => t[0] === "0" ? e : e.split("").map((n) => t[Number(n)]).join(""), lr = (e, t) => {
  const n = Re(e, t);
  return n !== " " && !Number.isNaN(Number(n));
}, eo = (e, t) => {
  let n = e;
  for (n = Number(n).toString(); n.length < t; )
    n = `0${n}`;
  return n;
}, to = (e, t, n, o, r) => {
  if (process.env.NODE_ENV !== "production" && r.type !== "day" && r.contentType === "digit-with-letter")
    throw new Error([`MUI X: The token "${r.format}" is a digit format with letter in it.'
             This type of format is only supported for 'day' sections`].join(`
`));
  if (r.type === "day" && r.contentType === "digit-with-letter") {
    const i = e.setDate(n.longestMonth, t);
    return e.formatByString(i, r.format);
  }
  let s = t.toString();
  return r.hasLeadingZerosInInput && (s = eo(s, r.maxLength)), Qn(s, o);
}, cr = (e, t, n, o, r, s, i, u) => {
  const l = Kn(o), c = o === "Home", f = o === "End", m = n.value === "" || c || f, b = () => {
    const d = r[n.type]({
      currentDate: i,
      format: n.format,
      contentType: n.contentType
    }), y = (V) => to(e, V, d, s, n), k = n.type === "minutes" && (u != null && u.minutesStep) ? u.minutesStep : 1;
    let M = parseInt(Re(n.value, s), 10) + l * k;
    if (m) {
      if (n.type === "year" && !f && !c)
        return e.formatByString(e.date(void 0, t), n.format);
      l > 0 || c ? M = d.minimum : M = d.maximum;
    }
    return M % k !== 0 && ((l < 0 || c) && (M += k - (k + M) % k), (l > 0 || f) && (M -= M % k)), M > d.maximum ? y(d.minimum + (M - d.maximum - 1) % (d.maximum - d.minimum + 1)) : M < d.minimum ? y(d.maximum - (d.minimum - M - 1) % (d.maximum - d.minimum + 1)) : y(M);
  }, g = () => {
    const d = Xn(e, t, n.type, n.format);
    if (d.length === 0)
      return n.value;
    if (m)
      return l > 0 || c ? d[0] : d[d.length - 1];
    const P = ((d.indexOf(n.value) + l) % d.length + d.length) % d.length;
    return d[P];
  };
  return n.contentType === "digit" || n.contentType === "digit-with-letter" ? b() : g();
}, Vt = (e, t, n) => {
  let o = e.value || e.placeholder;
  const r = t === "non-input" ? e.hasLeadingZerosInFormat : e.hasLeadingZerosInInput;
  return t === "non-input" && e.hasLeadingZerosInInput && !e.hasLeadingZerosInFormat && (o = Number(Re(o, n)).toString()), ["input-rtl", "input-ltr"].includes(t) && e.contentType === "digit" && !r && o.length === 1 && (o = `${o}‎`), t === "input-rtl" && (o = `⁨${o}⁩`), o;
}, ur = (e, t, n, o) => {
  if (process.env.NODE_ENV !== "production" && Zn(e, n).type === "weekDay")
    throw new Error("changeSectionValueFormat doesn't support week day formats");
  return e.formatByString(e.parse(t, n), o);
}, Nt = (e, t) => e.formatByString(e.date(void 0, "system"), t).length === 4, dr = (e, t, n, o) => {
  if (t !== "digit")
    return !1;
  const r = e.date(void 0, "default");
  switch (n) {
    case "year":
      return Nt(e, o) ? e.formatByString(e.setYear(r, 1), o) === "0001" : e.formatByString(e.setYear(r, 2001), o) === "01";
    case "month":
      return e.formatByString(e.startOfYear(r), o).length > 1;
    case "day":
      return e.formatByString(e.startOfMonth(r), o).length > 1;
    case "weekDay":
      return e.formatByString(e.startOfWeek(r), o).length > 1;
    case "hours":
      return e.formatByString(e.setHours(r, 1), o).length > 1;
    case "minutes":
      return e.formatByString(e.setMinutes(r, 1), o).length > 1;
    case "seconds":
      return e.formatByString(e.setSeconds(r, 1), o).length > 1;
    default:
      throw new Error("Invalid section type");
  }
}, mr = (e, t, n) => {
  const o = t.some((l) => l.type === "day"), r = [], s = [];
  for (let l = 0; l < t.length; l += 1) {
    const c = t[l];
    o && c.type === "weekDay" || (r.push(c.format), s.push(Vt(c, "non-input", n)));
  }
  const i = r.join(" "), u = s.join(" ");
  return e.parse(u, i);
}, no = (e) => e.map((t) => `${t.startSeparator}${t.value || t.placeholder}${t.endSeparator}`).join(""), oo = (e, t, n) => {
  const r = e.map((s) => {
    const i = Vt(s, n ? "input-rtl" : "input-ltr", t);
    return `${s.startSeparator}${i}${s.endSeparator}`;
  }).join("");
  return n ? `⁦${r}⁩` : r;
}, fr = (e, t, n) => {
  const o = e.date(void 0, n), r = e.endOfYear(o), s = e.endOfDay(o), {
    maxDaysInMonth: i,
    longestMonth: u
  } = xt(e, o).reduce((l, c) => {
    const f = e.getDaysInMonth(c);
    return f > l.maxDaysInMonth ? {
      maxDaysInMonth: f,
      longestMonth: c
    } : l;
  }, {
    maxDaysInMonth: 0,
    longestMonth: null
  });
  return {
    year: ({
      format: l
    }) => ({
      minimum: 0,
      maximum: Nt(e, l) ? 9999 : 99
    }),
    month: () => ({
      minimum: 1,
      // Assumption: All years have the same amount of months
      maximum: e.getMonth(r) + 1
    }),
    day: ({
      currentDate: l
    }) => ({
      minimum: 1,
      maximum: l != null && e.isValid(l) ? e.getDaysInMonth(l) : i,
      longestMonth: u
    }),
    weekDay: ({
      format: l,
      contentType: c
    }) => {
      if (c === "digit") {
        const f = et(e, l).map(Number);
        return {
          minimum: Math.min(...f),
          maximum: Math.max(...f)
        };
      }
      return {
        minimum: 1,
        maximum: 7
      };
    },
    hours: ({
      format: l
    }) => {
      const c = e.getHours(s);
      return Re(e.formatByString(e.endOfDay(o), l), t) !== c.toString() ? {
        minimum: 1,
        maximum: Number(Re(e.formatByString(e.startOfDay(o), l), t))
      } : {
        minimum: 0,
        maximum: c
      };
    },
    minutes: () => ({
      minimum: 0,
      // Assumption: All years have the same amount of minutes
      maximum: e.getMinutes(s)
    }),
    seconds: () => ({
      minimum: 0,
      // Assumption: All years have the same amount of seconds
      maximum: e.getSeconds(s)
    }),
    meridiem: () => ({
      minimum: 0,
      maximum: 1
    }),
    empty: () => ({
      minimum: 0,
      maximum: 0
    })
  };
};
let dt = !1;
const pr = (e, t) => {
  if (process.env.NODE_ENV !== "production" && !dt) {
    const n = ["empty"];
    ["date", "date-time"].includes(t) && n.push("weekDay", "day", "month", "year"), ["time", "date-time"].includes(t) && n.push("hours", "minutes", "seconds", "meridiem");
    const o = e.find((r) => !n.includes(r.type));
    o && (console.warn(`MUI X: The field component you are using is not compatible with the "${o.type}" date section.`, `The supported date sections are ["${n.join('", "')}"]\`.`), dt = !0);
  }
}, ro = (e, t, n, o) => {
  switch (t.type) {
    case "year":
      return e.setYear(o, e.getYear(n));
    case "month":
      return e.setMonth(o, e.getMonth(n));
    case "weekDay": {
      const r = et(e, t.format), s = e.formatByString(n, t.format), i = r.indexOf(s), l = r.indexOf(t.value) - i;
      return e.addDays(n, l);
    }
    case "day":
      return e.setDate(o, e.getDate(n));
    case "meridiem": {
      const r = e.getHours(n) < 12, s = e.getHours(o);
      return r && s >= 12 ? e.addHours(o, -12) : !r && s < 12 ? e.addHours(o, 12) : o;
    }
    case "hours":
      return e.setHours(o, e.getHours(n));
    case "minutes":
      return e.setMinutes(o, e.getMinutes(n));
    case "seconds":
      return e.setSeconds(o, e.getSeconds(n));
    default:
      return o;
  }
}, mt = {
  year: 1,
  month: 2,
  day: 3,
  weekDay: 4,
  hours: 5,
  minutes: 6,
  seconds: 7,
  meridiem: 8,
  empty: 9
}, hr = (e, t, n, o, r) => (
  // cloning sections before sort to avoid mutating it
  [...n].sort((s, i) => mt[s.type] - mt[i.type]).reduce((s, i) => !r || i.modified ? ro(e, i, t, s) : s, o)
), gr = () => navigator.userAgent.toLowerCase().includes("android"), br = (e, t) => {
  const n = {};
  if (!t)
    return e.forEach((l, c) => {
      const f = c === 0 ? null : c - 1, m = c === e.length - 1 ? null : c + 1;
      n[c] = {
        leftIndex: f,
        rightIndex: m
      };
    }), {
      neighbors: n,
      startIndex: 0,
      endIndex: e.length - 1
    };
  const o = {}, r = {};
  let s = 0, i = 0, u = e.length - 1;
  for (; u >= 0; ) {
    i = e.findIndex(
      // eslint-disable-next-line @typescript-eslint/no-loop-func
      (l, c) => {
        var f;
        return c >= s && ((f = l.endSeparator) == null ? void 0 : f.includes(" ")) && // Special case where the spaces were not there in the initial input
        l.endSeparator !== " / ";
      }
    ), i === -1 && (i = e.length - 1);
    for (let l = i; l >= s; l -= 1)
      r[l] = u, o[u] = l, u -= 1;
    s = i + 1;
  }
  return e.forEach((l, c) => {
    const f = r[c], m = f === 0 ? null : o[f - 1], b = f === e.length - 1 ? null : o[f + 1];
    n[c] = {
      leftIndex: m,
      rightIndex: b
    };
  }), {
    neighbors: n,
    startIndex: o[0],
    endIndex: o[e.length - 1]
  };
}, yr = (e, t) => {
  if (e == null)
    return null;
  if (e === "all")
    return "all";
  if (typeof e == "string") {
    const n = t.findIndex((o) => o.type === e);
    return n === -1 ? null : n;
  }
  return e;
}, wr = (e, t) => {
  if (e.value)
    switch (e.type) {
      case "month": {
        if (e.contentType === "digit")
          return t.format(t.setMonth(t.date(), Number(e.value) - 1), "month");
        const n = t.parse(e.value, e.format);
        return n ? t.format(n, "month") : void 0;
      }
      case "day":
        return e.contentType === "digit" ? t.format(t.setDate(t.startOfYear(t.date()), Number(e.value)), "dayOfMonthFull") : e.value;
      case "weekDay":
        return;
      default:
        return;
    }
}, vr = (e, t) => {
  if (e.value)
    switch (e.type) {
      case "weekDay":
        return e.contentType === "letter" ? void 0 : Number(e.value);
      case "meridiem": {
        const n = t.parse(`01:00 ${e.value}`, `${t.formats.hours12h}:${t.formats.minutes} ${e.format}`);
        return n ? t.getHours(n) >= 12 ? 1 : 0 : void 0;
      }
      case "day":
        return e.contentType === "digit-with-letter" ? parseInt(e.value, 10) : Number(e.value);
      case "month": {
        if (e.contentType === "digit")
          return Number(e.value);
        const n = t.parse(e.value, e.format);
        return n ? t.getMonth(n) + 1 : void 0;
      }
      default:
        return e.contentType !== "letter" ? Number(e.value) : void 0;
    }
}, so = ["value", "referenceDate"], ze = {
  emptyValue: null,
  getTodayValue: Je,
  getInitialReferenceValue: (e) => {
    let {
      value: t,
      referenceDate: n
    } = e, o = ie(e, so);
    return t != null && o.utils.isValid(t) ? t : n ?? qn(o);
  },
  cleanValue: Nn,
  areValuesEqual: On,
  isSameError: (e, t) => e === t,
  hasError: (e) => e != null,
  defaultErrorState: null,
  getTimezone: (e, t) => t == null || !e.isValid(t) ? null : e.getTimezone(t),
  setTimezone: (e, t, n) => n == null ? null : e.setTimezone(n, t)
}, Sr = {
  updateReferenceValue: (e, t, n) => t == null || !e.isValid(t) ? n : t,
  getSectionsFromValue: (e, t, n, o) => !e.isValid(t) && !!n ? n : o(t),
  getV7HiddenInputValueFromSections: no,
  getV6InputValueFromSections: oo,
  getActiveDateManager: (e, t) => ({
    date: t.value,
    referenceDate: t.referenceValue,
    getSections: (n) => n,
    getNewValuesFromNewActiveDate: (n) => ({
      value: n,
      referenceValue: n == null || !e.isValid(n) ? t.referenceValue : n
    })
  }),
  parseValueStr: (e, t, n) => n(e.trim(), t)
}, tt = ({
  value: e,
  referenceDate: t,
  utils: n,
  props: o,
  timezone: r
}) => {
  const s = p.useMemo(
    () => ze.getInitialReferenceValue({
      value: e,
      utils: n,
      props: o,
      referenceDate: t,
      granularity: ve.day,
      timezone: r,
      getTodayDate: () => Je(n, r, "date")
    }),
    // We only want to compute the reference date on mount.
    []
    // eslint-disable-line react-hooks/exhaustive-deps
  );
  return e ?? s;
}, ao = ["ampm", "ampmInClock", "autoFocus", "slots", "slotProps", "value", "defaultValue", "referenceDate", "disableIgnoringDatePartForTimeValidation", "maxTime", "minTime", "disableFuture", "disablePast", "minutesStep", "shouldDisableTime", "showViewSwitcher", "onChange", "view", "views", "openTo", "onViewChange", "focusedView", "onFocusedViewChange", "className", "disabled", "readOnly", "timezone"], io = (e) => {
  const {
    classes: t
  } = e;
  return Me({
    root: ["root"],
    arrowSwitcher: ["arrowSwitcher"]
  }, bn, t);
}, lo = B(Xe, {
  name: "MuiTimeClock",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  display: "flex",
  flexDirection: "column",
  position: "relative"
}), co = B(dn, {
  name: "MuiTimeClock",
  slot: "ArrowSwitcher",
  overridesResolver: (e, t) => t.arrowSwitcher
})({
  position: "absolute",
  right: 12,
  top: 15
}), uo = ["hours", "minutes"], Ot = /* @__PURE__ */ p.forwardRef(function(t, n) {
  const o = ge(), r = pe({
    props: t,
    name: "MuiTimeClock"
  }), {
    ampm: s = o.is12HourCycleInCurrentLocale(),
    ampmInClock: i = !1,
    autoFocus: u,
    slots: l,
    slotProps: c,
    value: f,
    defaultValue: m,
    referenceDate: b,
    disableIgnoringDatePartForTimeValidation: g = !1,
    maxTime: d,
    minTime: y,
    disableFuture: k,
    disablePast: P,
    minutesStep: M = 1,
    shouldDisableTime: V,
    showViewSwitcher: N,
    onChange: R,
    view: H,
    views: h = uo,
    openTo: x,
    onViewChange: O,
    focusedView: $,
    onFocusedViewChange: I,
    className: K,
    disabled: _,
    readOnly: ne,
    timezone: oe
  } = r, le = ie(r, ao), {
    value: ce,
    handleValueChange: X,
    timezone: de
  } = Qe({
    name: "TimeClock",
    timezone: oe,
    value: f,
    defaultValue: m,
    referenceDate: b,
    onChange: R,
    valueManager: ze
  }), F = tt({
    value: ce,
    referenceDate: b,
    utils: o,
    props: r,
    timezone: de
  }), z = Be(), G = Ze(de), {
    view: D,
    setView: A,
    previousView: Q,
    nextView: j,
    setValueAndGoToNextView: ee
  } = Ke({
    view: H,
    views: h,
    openTo: x,
    onViewChange: O,
    onChange: X,
    focusedView: $,
    onFocusedViewChange: I
  }), {
    meridiemMode: q,
    handleMeridiemChange: be
  } = Ct(F, s, ee), me = p.useCallback((W, U) => {
    const w = _e(g, o), L = U === "hours" || U === "minutes" && h.includes("seconds"), v = ({
      start: T,
      end: J
    }) => !(y && w(y, J) || d && w(T, d) || k && w(T, G) || P && w(G, L ? J : T)), S = (T, J = 1) => {
      if (T % J !== 0)
        return !1;
      if (V)
        switch (U) {
          case "hours":
            return !V(o.setHours(F, T), "hours");
          case "minutes":
            return !V(o.setMinutes(F, T), "minutes");
          case "seconds":
            return !V(o.setSeconds(F, T), "seconds");
          default:
            return !1;
        }
      return !0;
    };
    switch (U) {
      case "hours": {
        const T = Oe(W, q, s), J = o.setHours(F, T);
        if (o.getHours(J) !== T)
          return !0;
        const we = o.setSeconds(o.setMinutes(J, 0), 0), Ie = o.setSeconds(o.setMinutes(J, 59), 59);
        return !v({
          start: we,
          end: Ie
        }) || !S(T);
      }
      case "minutes": {
        const T = o.setMinutes(F, W), J = o.setSeconds(T, 0), we = o.setSeconds(T, 59);
        return !v({
          start: J,
          end: we
        }) || !S(W, M);
      }
      case "seconds": {
        const T = o.setSeconds(F, W);
        return !v({
          start: T,
          end: T
        }) || !S(W);
      }
      default:
        throw new Error("not supported");
    }
  }, [s, F, g, d, q, y, M, V, o, k, P, G, h]), Z = zt(), ke = p.useMemo(() => {
    switch (D) {
      case "hours": {
        const W = (L, v) => {
          const S = Oe(L, q, s);
          ee(o.setHours(F, S), v, "hours");
        }, U = o.getHours(F);
        let w;
        return s ? U > 12 ? w = [12, 23] : w = [0, 11] : w = [0, 23], {
          onChange: W,
          viewValue: U,
          children: Yn({
            value: ce,
            utils: o,
            ampm: s,
            onChange: W,
            getClockNumberText: z.hoursClockNumberText,
            isDisabled: (L) => _ || me(L, "hours"),
            selectedId: Z
          }),
          viewRange: w
        };
      }
      case "minutes": {
        const W = o.getMinutes(F), U = (w, L) => {
          ee(o.setMinutes(F, w), L, "minutes");
        };
        return {
          viewValue: W,
          onChange: U,
          children: ct({
            utils: o,
            value: W,
            onChange: U,
            getClockNumberText: z.minutesClockNumberText,
            isDisabled: (w) => _ || me(w, "minutes"),
            selectedId: Z
          }),
          viewRange: [0, 59]
        };
      }
      case "seconds": {
        const W = o.getSeconds(F), U = (w, L) => {
          ee(o.setSeconds(F, w), L, "seconds");
        };
        return {
          viewValue: W,
          onChange: U,
          children: ct({
            utils: o,
            value: W,
            onChange: U,
            getClockNumberText: z.secondsClockNumberText,
            isDisabled: (w) => _ || me(w, "seconds"),
            selectedId: Z
          }),
          viewRange: [0, 59]
        };
      }
      default:
        throw new Error("You must provide the type for ClockView");
    }
  }, [D, o, ce, s, z.hoursClockNumberText, z.minutesClockNumberText, z.secondsClockNumberText, q, ee, F, me, Z, _]), re = r, ye = io(re);
  return /* @__PURE__ */ Se(lo, E({
    ref: n,
    className: te(ye.root, K),
    ownerState: re
  }, le, {
    children: [/* @__PURE__ */ C(_n, E({
      autoFocus: u ?? !!$,
      ampmInClock: i && h.includes("hours"),
      value: ce,
      type: D,
      ampm: s,
      minutesStep: M,
      isTimeDisabled: me,
      meridiemMode: q,
      handleMeridiemChange: be,
      selectedId: Z,
      disabled: _,
      readOnly: ne
    }, ke)), N && /* @__PURE__ */ C(co, {
      className: ye.arrowSwitcher,
      slots: l,
      slotProps: c,
      onGoToPrevious: () => A(Q),
      isPreviousDisabled: !Q,
      previousLabel: z.openPreviousView,
      onGoToNext: () => A(j),
      isNextDisabled: !j,
      nextLabel: z.openNextView,
      ownerState: re
    })]
  }));
});
process.env.NODE_ENV !== "production" && (Ot.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * 12h/24h view for hour selection clock.
   * @default utils.is12HourCycleInCurrentLocale()
   */
  ampm: a.bool,
  /**
   * Display ampm controls under the clock (instead of in the toolbar).
   * @default false
   */
  ampmInClock: a.bool,
  /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */
  autoFocus: a.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: a.object,
  className: a.string,
  /**
   * The default selected value.
   * Used when the component is not controlled.
   */
  defaultValue: a.object,
  /**
   * If `true`, the picker views and text field are disabled.
   * @default false
   */
  disabled: a.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: a.bool,
  /**
   * Do not ignore date part when validating min/max time.
   * @default false
   */
  disableIgnoringDatePartForTimeValidation: a.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: a.bool,
  /**
   * Controlled focused view.
   */
  focusedView: a.oneOf(["hours", "minutes", "seconds"]),
  /**
   * Maximal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  maxTime: a.object,
  /**
   * Minimal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  minTime: a.object,
  /**
   * Step over minutes.
   * @default 1
   */
  minutesStep: a.number,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TView The view type. Will be one of date or time views.
   * @param {TValue} value The new value.
   * @param {PickerSelectionState | undefined} selectionState Indicates if the date selection is complete.
   * @param {TView | undefined} selectedView Indicates the view in which the selection has been made.
   */
  onChange: a.func,
  /**
   * Callback fired on focused view change.
   * @template TView
   * @param {TView} view The new view to focus or not.
   * @param {boolean} hasFocus `true` if the view should be focused.
   */
  onFocusedViewChange: a.func,
  /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */
  onViewChange: a.func,
  /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */
  openTo: a.oneOf(["hours", "minutes", "seconds"]),
  /**
   * If `true`, the picker views and text field are read-only.
   * @default false
   */
  readOnly: a.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid time using the validation props, except callbacks such as `shouldDisableTime`.
   */
  referenceDate: a.object,
  /**
   * Disable specific time.
   * @template TDate
   * @param {TDate} value The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   */
  shouldDisableTime: a.func,
  showViewSwitcher: a.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: a.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: a.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: a.oneOfType([a.arrayOf(a.oneOfType([a.func, a.object, a.bool])), a.func, a.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: a.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: a.object,
  /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */
  view: a.oneOf(["hours", "minutes", "seconds"]),
  /**
   * Available views.
   * @default ['hours', 'minutes']
   */
  views: a.arrayOf(a.oneOf(["hours", "minutes", "seconds"]).isRequired)
});
function mo(e) {
  return he("MuiDigitalClock", e);
}
const Cr = De("MuiDigitalClock", ["root", "list", "item"]);
function Mr(e, t) {
  return Array.isArray(t) ? t.every((n) => e.indexOf(n) !== -1) : e.indexOf(t) !== -1;
}
const Dr = (e, t) => (n) => {
  (n.key === "Enter" || n.key === " ") && (e(n), n.preventDefault(), n.stopPropagation());
}, Pt = (e = document) => {
  const t = e.activeElement;
  return t ? t.shadowRoot ? Pt(t.shadowRoot) : t : null;
}, Fe = (e) => Array.from(e.children).indexOf(Pt(document)), kr = "@media (pointer: fine)", fo = ["ampm", "timeStep", "autoFocus", "slots", "slotProps", "value", "defaultValue", "referenceDate", "disableIgnoringDatePartForTimeValidation", "maxTime", "minTime", "disableFuture", "disablePast", "minutesStep", "shouldDisableTime", "onChange", "view", "openTo", "onViewChange", "focusedView", "onFocusedViewChange", "className", "disabled", "readOnly", "views", "skipDisabled", "timezone"], po = (e) => {
  const {
    classes: t
  } = e;
  return Me({
    root: ["root"],
    list: ["list"],
    item: ["item"]
  }, mo, t);
}, ho = B(Xe, {
  name: "MuiDigitalClock",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  overflowY: "auto",
  width: "100%",
  "@media (prefers-reduced-motion: no-preference)": {
    scrollBehavior: "auto"
  },
  maxHeight: Mt,
  variants: [{
    props: {
      alreadyRendered: !0
    },
    style: {
      "@media (prefers-reduced-motion: no-preference)": {
        scrollBehavior: "smooth"
      }
    }
  }]
}), go = B(ht, {
  name: "MuiDigitalClock",
  slot: "List",
  overridesResolver: (e, t) => t.list
})({
  padding: 0
}), bo = B(pt, {
  name: "MuiDigitalClock",
  slot: "Item",
  overridesResolver: (e, t) => t.item
})(({
  theme: e
}) => ({
  padding: "8px 16px",
  margin: "2px 4px",
  "&:first-of-type": {
    marginTop: 4
  },
  "&:hover": {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.hoverOpacity})` : $e(e.palette.primary.main, e.palette.action.hoverOpacity)
  },
  "&.Mui-selected": {
    backgroundColor: (e.vars || e).palette.primary.main,
    color: (e.vars || e).palette.primary.contrastText,
    "&:focus-visible, &:hover": {
      backgroundColor: (e.vars || e).palette.primary.dark
    }
  },
  "&.Mui-focusVisible": {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.focusOpacity})` : $e(e.palette.primary.main, e.palette.action.focusOpacity)
  }
})), Rt = /* @__PURE__ */ p.forwardRef(function(t, n) {
  const o = ge(), r = p.useRef(null), s = Ge(n, r), i = p.useRef(null), u = pe({
    props: t,
    name: "MuiDigitalClock"
  }), {
    ampm: l = o.is12HourCycleInCurrentLocale(),
    timeStep: c = 30,
    autoFocus: f,
    slots: m,
    slotProps: b,
    value: g,
    defaultValue: d,
    referenceDate: y,
    disableIgnoringDatePartForTimeValidation: k = !1,
    maxTime: P,
    minTime: M,
    disableFuture: V,
    disablePast: N,
    minutesStep: R = 1,
    shouldDisableTime: H,
    onChange: h,
    view: x,
    openTo: O,
    onViewChange: $,
    focusedView: I,
    onFocusedViewChange: K,
    className: _,
    disabled: ne,
    readOnly: oe,
    views: le = ["hours"],
    skipDisabled: ce = !1,
    timezone: X
  } = u, de = ie(u, fo), {
    value: F,
    handleValueChange: z,
    timezone: G
  } = Qe({
    name: "DigitalClock",
    timezone: X,
    value: g,
    defaultValue: d,
    referenceDate: y,
    onChange: h,
    valueManager: ze
  }), D = Be(), A = Ze(G), Q = p.useMemo(() => E({}, u, {
    alreadyRendered: !!r.current
  }), [u]), j = po(Q), ee = (m == null ? void 0 : m.digitalClockItem) ?? bo, q = Ne({
    elementType: ee,
    externalSlotProps: b == null ? void 0 : b.digitalClockItem,
    ownerState: {},
    className: j.item
  }), be = tt({
    value: F,
    referenceDate: y,
    utils: o,
    props: u,
    timezone: G
  }), me = ae((w) => z(w, "finish", "hours")), {
    setValueAndGoToNextView: Z
  } = Ke({
    view: x,
    views: le,
    openTo: O,
    onViewChange: $,
    onChange: me,
    focusedView: I,
    onFocusedViewChange: K
  }), ke = ae((w) => {
    Z(w, "finish");
  });
  p.useEffect(() => {
    if (r.current === null)
      return;
    const w = r.current.querySelector('[role="listbox"] [role="option"][tabindex="0"], [role="listbox"] [role="option"][aria-selected="true"]');
    if (!w)
      return;
    const L = w.offsetTop;
    (f || I) && w.focus(), r.current.scrollTop = L - 4;
  });
  const re = p.useCallback((w) => {
    const L = _e(k, o), v = () => !(M && L(M, w) || P && L(w, P) || V && L(w, A) || N && L(A, w)), S = () => o.getMinutes(w) % R !== 0 ? !1 : H ? !H(w, "hours") : !0;
    return !v() || !S();
  }, [k, o, M, P, V, A, N, R, H]), ye = p.useMemo(() => {
    const w = [];
    let v = o.startOfDay(be);
    for (; o.isSameDay(be, v); )
      w.push(v), v = o.addMinutes(v, c);
    return w;
  }, [be, c, o]), W = ye.findIndex((w) => o.isEqual(w, be)), U = (w) => {
    switch (w.key) {
      case "PageUp": {
        const L = Fe(i.current) - 5, v = i.current.children, S = Math.max(0, L), T = v[S];
        T && T.focus(), w.preventDefault();
        break;
      }
      case "PageDown": {
        const L = Fe(i.current) + 5, v = i.current.children, S = Math.min(v.length - 1, L), T = v[S];
        T && T.focus(), w.preventDefault();
        break;
      }
    }
  };
  return /* @__PURE__ */ C(ho, E({
    ref: s,
    className: te(j.root, _),
    ownerState: Q
  }, de, {
    children: /* @__PURE__ */ C(go, {
      ref: i,
      role: "listbox",
      "aria-label": D.timePickerToolbarTitle,
      className: j.list,
      onKeyDown: U,
      children: ye.map((w, L) => {
        if (ce && re(w))
          return null;
        const v = o.isEqual(w, F), S = o.format(w, l ? "fullTime12h" : "fullTime24h"), T = W === L || W === -1 && L === 0 ? 0 : -1;
        return /* @__PURE__ */ C(ee, E({
          onClick: () => !oe && ke(w),
          selected: v,
          disabled: ne || re(w),
          disableRipple: oe,
          role: "option",
          "aria-disabled": oe,
          "aria-selected": v,
          tabIndex: T
        }, q, {
          children: S
        }), `${w.valueOf()}-${S}`);
      })
    })
  }));
});
process.env.NODE_ENV !== "production" && (Rt.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * 12h/24h view for hour selection clock.
   * @default utils.is12HourCycleInCurrentLocale()
   */
  ampm: a.bool,
  /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */
  autoFocus: a.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: a.object,
  className: a.string,
  /**
   * The default selected value.
   * Used when the component is not controlled.
   */
  defaultValue: a.object,
  /**
   * If `true`, the picker views and text field are disabled.
   * @default false
   */
  disabled: a.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: a.bool,
  /**
   * Do not ignore date part when validating min/max time.
   * @default false
   */
  disableIgnoringDatePartForTimeValidation: a.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: a.bool,
  /**
   * Controlled focused view.
   */
  focusedView: a.oneOf(["hours"]),
  /**
   * Maximal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  maxTime: a.object,
  /**
   * Minimal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  minTime: a.object,
  /**
   * Step over minutes.
   * @default 1
   */
  minutesStep: a.number,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TView The view type. Will be one of date or time views.
   * @param {TValue} value The new value.
   * @param {PickerSelectionState | undefined} selectionState Indicates if the date selection is complete.
   * @param {TView | undefined} selectedView Indicates the view in which the selection has been made.
   */
  onChange: a.func,
  /**
   * Callback fired on focused view change.
   * @template TView
   * @param {TView} view The new view to focus or not.
   * @param {boolean} hasFocus `true` if the view should be focused.
   */
  onFocusedViewChange: a.func,
  /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */
  onViewChange: a.func,
  /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */
  openTo: a.oneOf(["hours"]),
  /**
   * If `true`, the picker views and text field are read-only.
   * @default false
   */
  readOnly: a.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid time using the validation props, except callbacks such as `shouldDisableTime`.
   */
  referenceDate: a.object,
  /**
   * Disable specific time.
   * @template TDate
   * @param {TDate} value The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   */
  shouldDisableTime: a.func,
  /**
   * If `true`, disabled digital clock items will not be rendered.
   * @default false
   */
  skipDisabled: a.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: a.object,
  /**
   * Overrideable component slots.
   * @default {}
   */
  slots: a.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: a.oneOfType([a.arrayOf(a.oneOfType([a.func, a.object, a.bool])), a.func, a.object]),
  /**
   * The time steps between two time options.
   * For example, if `timeStep = 45`, then the available time options will be `[00:00, 00:45, 01:30, 02:15, 03:00, etc.]`.
   * @default 30
   */
  timeStep: a.number,
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: a.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: a.object,
  /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */
  view: a.oneOf(["hours"]),
  /**
   * Available views.
   * @default ['hours']
   */
  views: a.arrayOf(a.oneOf(["hours"]))
});
function yo(e) {
  return he("MuiMultiSectionDigitalClock", e);
}
const xr = De("MuiMultiSectionDigitalClock", ["root"]);
function wo(e) {
  return he("MuiMultiSectionDigitalClockSection", e);
}
const Tr = De("MuiMultiSectionDigitalClockSection", ["root", "item"]), vo = ["autoFocus", "onChange", "className", "disabled", "readOnly", "items", "active", "slots", "slotProps", "skipDisabled"], So = (e) => {
  const {
    classes: t
  } = e;
  return Me({
    root: ["root"],
    item: ["item"]
  }, wo, t);
}, Co = B(ht, {
  name: "MuiMultiSectionDigitalClockSection",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  theme: e
}) => ({
  maxHeight: Mt,
  width: 56,
  padding: 0,
  overflow: "hidden",
  "@media (prefers-reduced-motion: no-preference)": {
    scrollBehavior: "auto"
  },
  "@media (pointer: fine)": {
    "&:hover": {
      overflowY: "auto"
    }
  },
  "@media (pointer: none), (pointer: coarse)": {
    overflowY: "auto"
  },
  "&:not(:first-of-type)": {
    borderLeft: `1px solid ${(e.vars || e).palette.divider}`
  },
  "&::after": {
    display: "block",
    content: '""',
    // subtracting the height of one item, extra margin and borders to make sure the max height is correct
    height: "calc(100% - 40px - 6px)"
  },
  variants: [{
    props: {
      alreadyRendered: !0
    },
    style: {
      "@media (prefers-reduced-motion: no-preference)": {
        scrollBehavior: "smooth"
      }
    }
  }]
})), Mo = B(pt, {
  name: "MuiMultiSectionDigitalClockSection",
  slot: "Item",
  overridesResolver: (e, t) => t.item
})(({
  theme: e
}) => ({
  padding: 8,
  margin: "2px 4px",
  width: gn,
  justifyContent: "center",
  "&:first-of-type": {
    marginTop: 4
  },
  "&:hover": {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.hoverOpacity})` : $e(e.palette.primary.main, e.palette.action.hoverOpacity)
  },
  "&.Mui-selected": {
    backgroundColor: (e.vars || e).palette.primary.main,
    color: (e.vars || e).palette.primary.contrastText,
    "&:focus-visible, &:hover": {
      backgroundColor: (e.vars || e).palette.primary.dark
    }
  },
  "&.Mui-focusVisible": {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.focusOpacity})` : $e(e.palette.primary.main, e.palette.action.focusOpacity)
  }
})), Do = /* @__PURE__ */ p.forwardRef(function(t, n) {
  const o = p.useRef(null), r = Ge(n, o), s = p.useRef(null), i = pe({
    props: t,
    name: "MuiMultiSectionDigitalClockSection"
  }), {
    autoFocus: u,
    onChange: l,
    className: c,
    disabled: f,
    readOnly: m,
    items: b,
    active: g,
    slots: d,
    slotProps: y,
    skipDisabled: k
  } = i, P = ie(i, vo), M = p.useMemo(() => E({}, i, {
    alreadyRendered: !!o.current
  }), [i]), V = So(M), N = (d == null ? void 0 : d.digitalClockSectionItem) ?? Mo;
  p.useEffect(() => {
    if (o.current === null)
      return;
    const h = o.current.querySelector('[role="option"][tabindex="0"], [role="option"][aria-selected="true"]');
    if (g && u && h && h.focus(), !h || s.current === h)
      return;
    s.current = h;
    const x = h.offsetTop;
    o.current.scrollTop = x - 4;
  });
  const R = b.findIndex((h) => h.isFocused(h.value)), H = (h) => {
    switch (h.key) {
      case "PageUp": {
        const x = Fe(o.current) - 5, O = o.current.children, $ = Math.max(0, x), I = O[$];
        I && I.focus(), h.preventDefault();
        break;
      }
      case "PageDown": {
        const x = Fe(o.current) + 5, O = o.current.children, $ = Math.min(O.length - 1, x), I = O[$];
        I && I.focus(), h.preventDefault();
        break;
      }
    }
  };
  return /* @__PURE__ */ C(Co, E({
    ref: r,
    className: te(V.root, c),
    ownerState: M,
    autoFocusItem: u && g,
    role: "listbox",
    onKeyDown: H
  }, P, {
    children: b.map((h, x) => {
      var _;
      const O = (_ = h.isDisabled) == null ? void 0 : _.call(h, h.value), $ = f || O;
      if (k && $)
        return null;
      const I = h.isSelected(h.value), K = R === x || R === -1 && x === 0 ? 0 : -1;
      return /* @__PURE__ */ C(N, E({
        onClick: () => !m && l(h.value),
        selected: I,
        disabled: $,
        disableRipple: m,
        role: "option",
        "aria-disabled": m || $ || void 0,
        "aria-label": h.ariaLabel,
        "aria-selected": I,
        tabIndex: K,
        className: V.item
      }, y == null ? void 0 : y.digitalClockSectionItem, {
        children: h.label
      }), h.label);
    })
  }));
}), ko = ({
  now: e,
  value: t,
  utils: n,
  ampm: o,
  isDisabled: r,
  resolveAriaLabel: s,
  timeStep: i,
  valueOrReferenceDate: u
}) => {
  const l = t ? n.getHours(t) : null, c = [], f = (g, d) => {
    const y = d ?? l;
    return y === null ? !1 : o ? g === 12 ? y === 12 || y === 0 : y === g || y - 12 === g : y === g;
  }, m = (g) => f(g, n.getHours(u)), b = o ? 11 : 23;
  for (let g = 0; g <= b; g += i) {
    let d = n.format(n.setHours(e, g), o ? "hours12h" : "hours24h");
    const y = s(parseInt(d, 10).toString());
    d = n.formatNumber(d), c.push({
      value: g,
      label: d,
      isSelected: f,
      isDisabled: r,
      isFocused: m,
      ariaLabel: y
    });
  }
  return c;
}, ft = ({
  value: e,
  utils: t,
  isDisabled: n,
  timeStep: o,
  resolveLabel: r,
  resolveAriaLabel: s,
  hasValue: i = !0
}) => {
  const u = (c) => e === null ? !1 : i && e === c, l = (c) => e === c;
  return [...Array.from({
    length: Math.ceil(60 / o)
  }, (c, f) => {
    const m = o * f;
    return {
      value: m,
      label: t.formatNumber(r(m)),
      isDisabled: n,
      isSelected: u,
      isFocused: l,
      ariaLabel: s(m.toString())
    };
  })];
}, xo = ["ampm", "timeSteps", "autoFocus", "slots", "slotProps", "value", "defaultValue", "referenceDate", "disableIgnoringDatePartForTimeValidation", "maxTime", "minTime", "disableFuture", "disablePast", "minutesStep", "shouldDisableTime", "onChange", "view", "views", "openTo", "onViewChange", "focusedView", "onFocusedViewChange", "className", "disabled", "readOnly", "skipDisabled", "timezone"], To = (e) => {
  const {
    classes: t
  } = e;
  return Me({
    root: ["root"]
  }, yo, t);
}, Io = B(Xe, {
  name: "MuiMultiSectionDigitalClock",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  theme: e
}) => ({
  display: "flex",
  flexDirection: "row",
  width: "100%",
  borderBottom: `1px solid ${(e.vars || e).palette.divider}`
})), Et = /* @__PURE__ */ p.forwardRef(function(t, n) {
  const o = ge(), r = yt(), s = pe({
    props: t,
    name: "MuiMultiSectionDigitalClock"
  }), {
    ampm: i = o.is12HourCycleInCurrentLocale(),
    timeSteps: u,
    autoFocus: l,
    slots: c,
    slotProps: f,
    value: m,
    defaultValue: b,
    referenceDate: g,
    disableIgnoringDatePartForTimeValidation: d = !1,
    maxTime: y,
    minTime: k,
    disableFuture: P,
    disablePast: M,
    minutesStep: V = 1,
    shouldDisableTime: N,
    onChange: R,
    view: H,
    views: h = ["hours", "minutes"],
    openTo: x,
    onViewChange: O,
    focusedView: $,
    onFocusedViewChange: I,
    className: K,
    disabled: _,
    readOnly: ne,
    skipDisabled: oe = !1,
    timezone: le
  } = s, ce = ie(s, xo), {
    value: X,
    handleValueChange: de,
    timezone: F
  } = Qe({
    name: "MultiSectionDigitalClock",
    timezone: le,
    value: m,
    defaultValue: b,
    referenceDate: g,
    onChange: R,
    valueManager: ze
  }), z = Be(), G = Ze(F), D = p.useMemo(() => E({
    hours: 1,
    minutes: 5,
    seconds: 5
  }, u), [u]), A = tt({
    value: X,
    referenceDate: g,
    utils: o,
    props: s,
    timezone: F
  }), Q = ae((v, S, T) => de(v, S, T)), j = p.useMemo(() => !i || !h.includes("hours") || h.includes("meridiem") ? h : [...h, "meridiem"], [i, h]), {
    view: ee,
    setValueAndGoToNextView: q,
    focusedView: be
  } = Ke({
    view: H,
    views: j,
    openTo: x,
    onViewChange: O,
    onChange: Q,
    focusedView: $,
    onFocusedViewChange: I
  }), me = ae((v) => {
    q(v, "finish", "meridiem");
  }), {
    meridiemMode: Z,
    handleMeridiemChange: ke
  } = Ct(A, i, me, "finish"), re = p.useCallback((v, S) => {
    const T = _e(d, o), J = S === "hours" || S === "minutes" && j.includes("seconds"), we = ({
      start: Y,
      end: se
    }) => !(k && T(k, se) || y && T(Y, y) || P && T(Y, G) || M && T(G, J ? se : Y)), Ie = (Y, se = 1) => {
      if (Y % se !== 0)
        return !1;
      if (N)
        switch (S) {
          case "hours":
            return !N(o.setHours(A, Y), "hours");
          case "minutes":
            return !N(o.setMinutes(A, Y), "minutes");
          case "seconds":
            return !N(o.setSeconds(A, Y), "seconds");
          default:
            return !1;
        }
      return !0;
    };
    switch (S) {
      case "hours": {
        const Y = Oe(v, Z, i), se = o.setHours(A, Y);
        if (o.getHours(se) !== Y)
          return !0;
        const Ee = o.setSeconds(o.setMinutes(se, 0), 0), At = o.setSeconds(o.setMinutes(se, 59), 59);
        return !we({
          start: Ee,
          end: At
        }) || !Ie(Y);
      }
      case "minutes": {
        const Y = o.setMinutes(A, v), se = o.setSeconds(Y, 0), Ee = o.setSeconds(Y, 59);
        return !we({
          start: se,
          end: Ee
        }) || !Ie(v, V);
      }
      case "seconds": {
        const Y = o.setSeconds(A, v);
        return !we({
          start: Y,
          end: Y
        }) || !Ie(v);
      }
      default:
        throw new Error("not supported");
    }
  }, [i, A, d, y, Z, k, V, N, o, P, M, G, j]), ye = p.useCallback((v) => {
    switch (v) {
      case "hours":
        return {
          onChange: (S) => {
            const T = Oe(S, Z, i);
            q(o.setHours(A, T), "finish", "hours");
          },
          items: ko({
            now: G,
            value: X,
            ampm: i,
            utils: o,
            isDisabled: (S) => re(S, "hours"),
            timeStep: D.hours,
            resolveAriaLabel: z.hoursClockNumberText,
            valueOrReferenceDate: A
          })
        };
      case "minutes":
        return {
          onChange: (S) => {
            q(o.setMinutes(A, S), "finish", "minutes");
          },
          items: ft({
            value: o.getMinutes(A),
            utils: o,
            isDisabled: (S) => re(S, "minutes"),
            resolveLabel: (S) => o.format(o.setMinutes(G, S), "minutes"),
            timeStep: D.minutes,
            hasValue: !!X,
            resolveAriaLabel: z.minutesClockNumberText
          })
        };
      case "seconds":
        return {
          onChange: (S) => {
            q(o.setSeconds(A, S), "finish", "seconds");
          },
          items: ft({
            value: o.getSeconds(A),
            utils: o,
            isDisabled: (S) => re(S, "seconds"),
            resolveLabel: (S) => o.format(o.setSeconds(G, S), "seconds"),
            timeStep: D.seconds,
            hasValue: !!X,
            resolveAriaLabel: z.secondsClockNumberText
          })
        };
      case "meridiem": {
        const S = xe(o, "am"), T = xe(o, "pm");
        return {
          onChange: ke,
          items: [{
            value: "am",
            label: S,
            isSelected: () => !!X && Z === "am",
            isFocused: () => !!A && Z === "am",
            ariaLabel: S
          }, {
            value: "pm",
            label: T,
            isSelected: () => !!X && Z === "pm",
            isFocused: () => !!A && Z === "pm",
            ariaLabel: T
          }]
        };
      }
      default:
        throw new Error(`Unknown view: ${v} found.`);
    }
  }, [G, X, i, o, D.hours, D.minutes, D.seconds, z.hoursClockNumberText, z.minutesClockNumberText, z.secondsClockNumberText, Z, q, A, re, ke]), W = p.useMemo(() => {
    if (!r)
      return j;
    const v = j.filter((S) => S !== "meridiem");
    return v.reverse(), j.includes("meridiem") && v.push("meridiem"), v;
  }, [r, j]), U = p.useMemo(() => j.reduce((v, S) => E({}, v, {
    [S]: ye(S)
  }), {}), [j, ye]), w = s, L = To(w);
  return /* @__PURE__ */ C(Io, E({
    ref: n,
    className: te(L.root, K),
    ownerState: w,
    role: "group"
  }, ce, {
    children: W.map((v) => /* @__PURE__ */ C(Do, {
      items: U[v].items,
      onChange: U[v].onChange,
      active: ee === v,
      autoFocus: l ?? be === v,
      disabled: _,
      readOnly: ne,
      slots: c,
      slotProps: f,
      skipDisabled: oe,
      "aria-label": z.selectViewText(v)
    }, v))
  }));
});
process.env.NODE_ENV !== "production" && (Et.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * 12h/24h view for hour selection clock.
   * @default utils.is12HourCycleInCurrentLocale()
   */
  ampm: a.bool,
  /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */
  autoFocus: a.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: a.object,
  className: a.string,
  /**
   * The default selected value.
   * Used when the component is not controlled.
   */
  defaultValue: a.object,
  /**
   * If `true`, the picker views and text field are disabled.
   * @default false
   */
  disabled: a.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: a.bool,
  /**
   * Do not ignore date part when validating min/max time.
   * @default false
   */
  disableIgnoringDatePartForTimeValidation: a.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: a.bool,
  /**
   * Controlled focused view.
   */
  focusedView: a.oneOf(["hours", "meridiem", "minutes", "seconds"]),
  /**
   * Maximal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  maxTime: a.object,
  /**
   * Minimal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  minTime: a.object,
  /**
   * Step over minutes.
   * @default 1
   */
  minutesStep: a.number,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TView The view type. Will be one of date or time views.
   * @param {TValue} value The new value.
   * @param {PickerSelectionState | undefined} selectionState Indicates if the date selection is complete.
   * @param {TView | undefined} selectedView Indicates the view in which the selection has been made.
   */
  onChange: a.func,
  /**
   * Callback fired on focused view change.
   * @template TView
   * @param {TView} view The new view to focus or not.
   * @param {boolean} hasFocus `true` if the view should be focused.
   */
  onFocusedViewChange: a.func,
  /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */
  onViewChange: a.func,
  /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */
  openTo: a.oneOf(["hours", "meridiem", "minutes", "seconds"]),
  /**
   * If `true`, the picker views and text field are read-only.
   * @default false
   */
  readOnly: a.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid time using the validation props, except callbacks such as `shouldDisableTime`.
   */
  referenceDate: a.object,
  /**
   * Disable specific time.
   * @template TDate
   * @param {TDate} value The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   */
  shouldDisableTime: a.func,
  /**
   * If `true`, disabled digital clock items will not be rendered.
   * @default false
   */
  skipDisabled: a.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: a.object,
  /**
   * Overrideable component slots.
   * @default {}
   */
  slots: a.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: a.oneOfType([a.arrayOf(a.oneOfType([a.func, a.object, a.bool])), a.func, a.object]),
  /**
   * The time steps between two time unit options.
   * For example, if `timeStep.minutes = 8`, then the available minute options will be `[0, 8, 16, 24, 32, 40, 48, 56]`.
   * @default{ hours: 1, minutes: 5, seconds: 5 }
   */
  timeSteps: a.shape({
    hours: a.number,
    minutes: a.number,
    seconds: a.number
  }),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: a.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: a.object,
  /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */
  view: a.oneOf(["hours", "meridiem", "minutes", "seconds"]),
  /**
   * Available views.
   * @default ['hours', 'minutes']
   */
  views: a.arrayOf(a.oneOf(["hours", "meridiem", "minutes", "seconds"]).isRequired)
});
const Ir = ({
  view: e,
  onViewChange: t,
  focusedView: n,
  onFocusedViewChange: o,
  views: r,
  value: s,
  defaultValue: i,
  referenceDate: u,
  onChange: l,
  className: c,
  classes: f,
  disableFuture: m,
  disablePast: b,
  minTime: g,
  maxTime: d,
  shouldDisableTime: y,
  minutesStep: k,
  ampm: P,
  ampmInClock: M,
  slots: V,
  slotProps: N,
  readOnly: R,
  disabled: H,
  sx: h,
  autoFocus: x,
  showViewSwitcher: O,
  disableIgnoringDatePartForTimeValidation: $,
  timezone: I
}) => /* @__PURE__ */ C(Ot, {
  view: e,
  onViewChange: t,
  focusedView: n && He(n) ? n : null,
  onFocusedViewChange: o,
  views: r.filter(He),
  value: s,
  defaultValue: i,
  referenceDate: u,
  onChange: l,
  className: c,
  classes: f,
  disableFuture: m,
  disablePast: b,
  minTime: g,
  maxTime: d,
  shouldDisableTime: y,
  minutesStep: k,
  ampm: P,
  ampmInClock: M,
  slots: V,
  slotProps: N,
  readOnly: R,
  disabled: H,
  sx: h,
  autoFocus: x,
  showViewSwitcher: O,
  disableIgnoringDatePartForTimeValidation: $,
  timezone: I
}), Vr = ({
  view: e,
  onViewChange: t,
  focusedView: n,
  onFocusedViewChange: o,
  views: r,
  value: s,
  defaultValue: i,
  referenceDate: u,
  onChange: l,
  className: c,
  classes: f,
  disableFuture: m,
  disablePast: b,
  minTime: g,
  maxTime: d,
  shouldDisableTime: y,
  minutesStep: k,
  ampm: P,
  slots: M,
  slotProps: V,
  readOnly: N,
  disabled: R,
  sx: H,
  autoFocus: h,
  disableIgnoringDatePartForTimeValidation: x,
  timeSteps: O,
  skipDisabled: $,
  timezone: I
}) => /* @__PURE__ */ C(Rt, {
  view: e,
  onViewChange: t,
  focusedView: n,
  onFocusedViewChange: o,
  views: r.filter(He),
  value: s,
  defaultValue: i,
  referenceDate: u,
  onChange: l,
  className: c,
  classes: f,
  disableFuture: m,
  disablePast: b,
  minTime: g,
  maxTime: d,
  shouldDisableTime: y,
  minutesStep: k,
  ampm: P,
  slots: M,
  slotProps: V,
  readOnly: N,
  disabled: R,
  sx: H,
  autoFocus: h,
  disableIgnoringDatePartForTimeValidation: x,
  timeStep: O == null ? void 0 : O.minutes,
  skipDisabled: $,
  timezone: I
}), Nr = ({
  view: e,
  onViewChange: t,
  focusedView: n,
  onFocusedViewChange: o,
  views: r,
  value: s,
  defaultValue: i,
  referenceDate: u,
  onChange: l,
  className: c,
  classes: f,
  disableFuture: m,
  disablePast: b,
  minTime: g,
  maxTime: d,
  shouldDisableTime: y,
  minutesStep: k,
  ampm: P,
  slots: M,
  slotProps: V,
  readOnly: N,
  disabled: R,
  sx: H,
  autoFocus: h,
  disableIgnoringDatePartForTimeValidation: x,
  timeSteps: O,
  skipDisabled: $,
  timezone: I
}) => /* @__PURE__ */ C(Et, {
  view: e,
  onViewChange: t,
  focusedView: n,
  onFocusedViewChange: o,
  views: r.filter(He),
  value: s,
  defaultValue: i,
  referenceDate: u,
  onChange: l,
  className: c,
  classes: f,
  disableFuture: m,
  disablePast: b,
  minTime: g,
  maxTime: d,
  shouldDisableTime: y,
  minutesStep: k,
  ampm: P,
  slots: M,
  slotProps: V,
  readOnly: N,
  disabled: R,
  sx: H,
  autoFocus: h,
  disableIgnoringDatePartForTimeValidation: x,
  timeSteps: O,
  skipDisabled: $,
  timezone: I
}), Vo = $t(Lt, {
  shouldForwardProp: (e) => !["subtitle", "destructive", "extended", "fixed", "iconColor"].includes(
    e
  )
})(
  ({
    theme: e,
    dense: t,
    subtitle: n,
    destructive: o,
    extended: r,
    fixed: s,
    iconColor: i = "primary"
  }) => ({
    ...n && {
      pointerEvents: "none",
      columnGap: 0,
      ...e.typography.caption,
      fontWeight: 500,
      color: e.palette.text.secondary,
      ".MuiListItemText-root .MuiTypography-root": {
        ...e.typography.caption,
        fontWeight: 500,
        color: e.palette.text.secondary
      },
      "&.MuiMenuItem-root": {
        minHeight: e.spacing(3),
        paddingTop: 0,
        paddingBottom: 0,
        marginTop: e.spacing(1),
        "&:not(:first-of-type)": {
          marginTop: e.spacing(2),
          "&::before": {
            content: '""',
            position: "absolute",
            top: e.spacing(-1),
            left: 0,
            right: 0,
            height: 1,
            backgroundColor: e.palette.divider
          }
        }
      }
    },
    ...i === "primary" && {
      ".MuiListItemIcon-root svg path": {
        fill: e.palette.text.primary
      },
      "&.Mui-selected .MuiListItemIcon-root svg path": {
        fill: e.palette.primary.main
      },
      '.MuiAutocomplete-listbox &[aria-selected="true"] svg path': {
        fill: e.palette.primary.main
      }
    },
    ...o && {
      color: e.palette.error.main,
      ".MuiTypography-root": {
        color: e.palette.error.main
      },
      "svg, & .MuiSvgIcon-root": {
        color: e.palette.error.main
      },
      ".MuiListItemIcon-root svg path": {
        fill: e.palette.error.main
      },
      "&.Mui-selected .MuiListItemIcon-root svg path": {
        fill: e.palette.error.main
      },
      "&:hover": {
        backgroundColor: e.palette.error.relatedLight
      },
      "&.Mui-selected": {
        color: e.palette.error.main,
        ".MuiTypography-root": {
          color: e.palette.error.main
        },
        "svg, & .MuiSvgIcon-root": {
          color: e.palette.error.main
        }
      },
      "&.Mui-disabled": {
        color: e.palette.text.disabled,
        ".MuiTypography-root": {
          color: e.palette.text.disabled
        },
        svg: {
          color: e.palette.text.disabled
        }
      }
    },
    ...r && {
      "&.MuiButtonBase-root.MuiMenuItem-root": {
        minHeight: e.spacing(6)
      }
    },
    ...s && {
      "&.MuiMenuItem-root": {
        position: "sticky",
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        zIndex: 2,
        minHeight: e.spacing(6),
        marginBottom: e.spacing(1),
        padding: e.spacing(0.5, 1.5),
        backgroundColor: `${e.palette.background.paper} !important`,
        borderBottom: `1px solid ${e.palette.divider}`
      },
      ".MuiAutocomplete-listbox &.MuiAutocomplete-option:first-of-type": {
        minHeight: e.spacing(6),
        marginTop: 0,
        "&:hover": {
          backgroundColor: e.palette.background.paper
        }
      }
    },
    ...!s && {
      ".MuiList-root &:first-of-type": {
        marginTop: e.spacing(1)
      }
    },
    ...t && {
      "&.MuiButtonBase-root.MuiMenuItem-root": {
        minHeight: e.spacing(3),
        padding: e.spacing(0.25, 1.5)
      }
    }
  })
);
function Or(e) {
  return /* @__PURE__ */ C(Vo, { ...e });
}
export {
  tr as $,
  We as A,
  yr as B,
  mr as C,
  Jo as D,
  hr as E,
  lr as F,
  ur as G,
  et as H,
  to as I,
  Xn as J,
  zt as K,
  Pt as L,
  Or as M,
  vr as N,
  wr as O,
  gr as P,
  Vt as Q,
  br as R,
  cr as S,
  Ne as T,
  Yo as U,
  Jt as V,
  Bo as W,
  Sr as X,
  ve as Y,
  Ze as Z,
  ie as _,
  he as a,
  sr as a0,
  pn as a1,
  Qe as a2,
  xt as a3,
  er as a4,
  _o as a5,
  Ko as a6,
  Xo as a7,
  dn as a8,
  Xe as a9,
  hn as aa,
  Ke as ab,
  Ue as ac,
  rr as ad,
  Go as ae,
  He as af,
  Mr as ag,
  or as ah,
  zo as ai,
  Kt as aj,
  Fo as ak,
  Dr as al,
  kr as am,
  Ct as an,
  xe as ao,
  Zo as ap,
  qo as aq,
  Nr as ar,
  jo as as,
  Ir as at,
  Wo as au,
  Uo as av,
  gn as aw,
  xr as ax,
  Tr as ay,
  Cr as az,
  Qo as b,
  Ge as c,
  wt as d,
  te as e,
  Me as f,
  De as g,
  nr as h,
  _e as i,
  qe as j,
  ae as k,
  Zn as l,
  dr as m,
  Qn as n,
  eo as o,
  Re as p,
  Be as q,
  Vr as r,
  ze as s,
  yt as t,
  ge as u,
  Gn as v,
  ir as w,
  fr as x,
  pr as y,
  ar as z
};
